"use strict";
/* eslint-disable no-unused-vars */
/* global jQuery */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.firstNonNil = exports.unfold = exports.bootstrapVersion = exports.uniqueKey = exports.iterateKey = exports.delay = exports.fieldData = exports.getCurrencyAffixes = exports.getNumberDecimalLimit = exports.getNumberSeparators = exports.matchInputMask = exports.unmaskValue = exports.getInputMask = exports.convertFormatToMask = exports.convertFormatToMoment = exports.convertFormatToFlatpickr = exports.getLocaleDateFormatInfo = exports.formatOffset = exports.formatDate = exports.momentDate = exports.loadZones = exports.shouldLoadZones = exports.zonesLoaded = exports.offsetDate = exports.currentTimezone = exports.isValidDate = exports.getDateSetting = exports.guid = exports.uniqueName = exports.convertStringToHTMLElement = exports.unescapeHTML = exports.removeHTML = exports.setActionProperty = exports.checkTrigger = exports.checkCondition = exports.checkJsonConditional = exports.checkCustomConditional = exports.getComponentActualValue = exports.checkSimpleConditional = exports.checkCalculated = exports.isMongoId = exports.boolValue = exports.getScriptPlugin = exports.getElementRect = exports.getPropertyValue = exports.getRandomComponentId = exports.evaluate = exports.moment = exports.ConditionOperators = exports.jsonLogic = void 0;
exports.mappingData = exports.numberToText = exports.getLangText = exports.numberToEnglishText = exports.setVariableTemp = exports.setVariable = exports.getVariableTemp = exports.getVariable = exports.encryptPassword = exports.getValueByCode = exports.getWindowConfig = exports.clearLoginInforClient = exports.formatUrl = exports.getContentUrl = exports.getParamUrl = exports.analysisUrl = exports.decryptIndexDB = exports.encryptIndexDB = exports.toastwarning = exports.toasterror = exports.toastsuccess = exports.toast = exports.customShowPopUp = exports.showPopup = exports.interpolateErrors = exports.getComponentSavedTypes = exports.componentValueTypes = exports._ = exports.getFocusableElements = exports.isInsideScopingComponent = exports.isPromise = exports.getDataParentComponent = exports.getComponentPath = exports.getComponentPathWithoutIndicies = exports.getBrowserInfo = exports.getIEBrowserVersion = exports.round = exports.getStringFromComponentPath = exports.isChildOf = exports.getArrayFromComponentPath = exports.isInputComponent = exports.interpolate = exports.Evaluator = exports.fastCloneDeep = exports.sanitize = exports.translateHTMLTemplate = exports.getContextButtons = exports.getContextComponents = exports.observeOverload = exports.withSwitch = void 0;
exports.callAPINextStep = exports.viewTaskDetail = exports.scrollToTop = exports.getAllFormComponents = exports.removeLoadingFullScreen = exports.loadingFullScreen = exports.removeLoadingAnimation = exports.loadingAnimation = exports.handleCAllAPI = exports.decryptResponse = exports.getBaseURL = exports.encryptRequest = exports.getKeysByType = exports.getClientInfo = exports.getDeviceId = exports.generateRandomString = exports.generateUUID = exports.dynamicFormatTemplate = exports.dynamicFormat = exports.numberWithCommas = exports.comfirmwithInput = exports.runJSFromString = exports.cdr = exports.cer = exports.formatParamString = exports.invokeMobileFunction = exports.safeParse = exports.excecAsyncAPIExternalFunction = exports.excecAPIExternalFunction = exports.execAsyncExternalFunction = exports.execExternalFunction = exports.getParamConfig = exports.deleteAllCache = exports.getCache = exports.saveCache = void 0;
const lodash_1 = __importDefault(require("lodash"));
exports._ = lodash_1.default;
const json_logic_js_1 = __importDefault(require("json-logic-js"));
exports.jsonLogic = json_logic_js_1.default;
const moment_timezone_1 = __importDefault(require("moment-timezone/moment-timezone"));
exports.moment = moment_timezone_1.default;
const jstimezonedetect_1 = __importDefault(require("jstimezonedetect"));
const operators_1 = require("./jsonlogic/operators");
const dompurify_1 = __importDefault(require("dompurify"));
const formUtils_1 = require("./formUtils");
const Evaluator_1 = require("./Evaluator");
Object.defineProperty(exports, "Evaluator", { enumerable: true, get: function () { return Evaluator_1.Evaluator; } });
const conditionOperators_1 = __importDefault(require("./conditionOperators"));
exports.ConditionOperators = conditionOperators_1.default;
//Simple
const encrypt_1 = require("./encrypt");
const sha256_1 = __importDefault(require("sha256"));
const myanmar_num_to_word_1 = require("myanmar-num-to-word");
const i18next_1 = __importDefault(require("i18next"));
const toastr_1 = __importDefault(require("toastr"));
//End Simple
//Fiona
const AriForm_1 = require("../AriForm");
const sweetalert_1 = __importDefault(require("sweetalert"));
const browser_cookies_1 = require("browser-cookies");
//end Fiona
const interpolate = Evaluator_1.Evaluator.interpolate;
exports.interpolate = interpolate;
__exportStar(require("./formUtils"), exports);
// Configure JsonLogic
operators_1.lodashOperators.forEach((name) => json_logic_js_1.default.add_operation(`_${name}`, lodash_1.default[name]));
// Retrieve Any Date
json_logic_js_1.default.add_operation('getDate', (date) => {
    return (0, moment_timezone_1.default)(date).toISOString();
});
// Set Relative Minimum Date
json_logic_js_1.default.add_operation('relativeMinDate', (relativeMinDate) => {
    return (0, moment_timezone_1.default)().subtract(relativeMinDate, 'days').toISOString();
});
// Set Relative Maximum Date
json_logic_js_1.default.add_operation('relativeMaxDate', (relativeMaxDate) => {
    return (0, moment_timezone_1.default)().add(relativeMaxDate, 'days').toISOString();
});
/**
 * Evaluate a method.
 * @param {Function|string|object} func - The function to evaluate.
 * @param {*} args - A map of arguments to pass to the function.
 * @param {string} ret - The name of the "return" variable in the script.
 * @param {boolean} interpolate - True if the script should be interpolated before being executed.
 * @param {import('@ariform/core').EvaluatorOptions} options - The evaluator options.
 * @returns {*} - The result of the evaluation.
 */
function evaluate(func, args, ret, interpolate, options = {}) {
    return Evaluator_1.Evaluator.evaluate(func, args, ret, interpolate, undefined, options);
}
exports.evaluate = evaluate;
/**
 * Returns a random compoennt ID.
 * @returns {string} - A random component ID.
 */
function getRandomComponentId() {
    return `e${Math.random().toString(36).substring(7)}`;
}
exports.getRandomComponentId = getRandomComponentId;
/**
 * Get a property value of an element.
 * @param {CSSStyleDeclaration} style - The style element to get the property value from.
 * @param {string} prop - The property to get the value for.
 * @returns {number} - The value of the property.
 */
function getPropertyValue(style, prop) {
    let value = style.getPropertyValue(prop);
    value = value ? value.replace(/[^0-9.]/g, '') : '0';
    return parseFloat(value);
}
exports.getPropertyValue = getPropertyValue;
/**
 * Get an elements bounding rectagle.
 * @param {HTMLElement} element - A DOM element to get the bounding rectangle for.
 * @returns {{x: number, y: number, width: number, height: number}} - The bounding rectangle.
 */
function getElementRect(element) {
    const style = window.getComputedStyle(element, null);
    return {
        x: getPropertyValue(style, 'left'),
        y: getPropertyValue(style, 'top'),
        width: getPropertyValue(style, 'width'),
        height: getPropertyValue(style, 'height')
    };
}
exports.getElementRect = getElementRect;
/**
 * Get non HTMLElement property in the window object
 * @param {string} property - The window property to fetch the script plugin from.
 * @returns {any | undefined} - The HTML Element property on the window object.
 */
function getScriptPlugin(property) {
    const obj = window[property];
    if (typeof HTMLElement === 'object' ? obj instanceof HTMLElement : //DOM2
        obj && typeof obj === 'object' && true && obj.nodeType === 1 && typeof obj.nodeName === 'string') {
        return undefined;
    }
    return obj;
}
exports.getScriptPlugin = getScriptPlugin;
/**
 * Determines the boolean value of a setting.
 * @param {string|boolean} value - A string or boolean value to convert to boolean.
 * @returns {boolean} - The boolean value of the setting.
 */
function boolValue(value) {
    if (lodash_1.default.isBoolean(value)) {
        return value;
    }
    else if (lodash_1.default.isString(value)) {
        return (value.toLowerCase() === 'true');
    }
    else {
        return !!value;
    }
}
exports.boolValue = boolValue;
/**
 * Check to see if an ID is a mongoID.
 * @param {string} text - The text to check if it is a mongoID.
 * @returns {boolean} - TRUE if the text is a mongoID; FALSE otherwise.
 */
function isMongoId(text) {
    return !!text.toString().match(/^[0-9a-fA-F]{24}$/);
}
exports.isMongoId = isMongoId;
/**
 * Checks the calculated value for a provided component and data.
 * @param {import('@ariform/core').Component} component - The component to check for the calculated value.
 * @param {import('@ariform/core').Submission} submission - A submission object.
 * @param {*} rowData - The contextual row data for the component.
 */
function checkCalculated(component, submission, rowData) {
    // Process calculated value stuff if present.
    if (component.calculateValue) {
        lodash_1.default.set(rowData, component.key, evaluate(component.calculateValue, {
            value: undefined,
            data: submission ? submission.data : rowData,
            row: rowData,
            util: this,
            component
        }, 'value'));
    }
}
exports.checkCalculated = checkCalculated;
/**
 * Check if a simple conditional evaluates to true.
 * @param {import('@ariform/core').Component} component - The component to check for the conditional.
 * @param {import('@ariform/core').SimpleConditional} condition - The condition to check.
 * @param {*} row - The row data for the component.
 * @param {*} data - The full submission data.
 * @param {import('../components/_classes/component/Component').Component} instance - The instance of the component.
 * @returns {boolean} - TRUE if the condition is true; FALSE otherwise.
 */
/**
 *
 * @param conditionPaths
 * @param data
 */
function getConditionalPathsRecursive(conditionPaths, data) {
    let currentGlobalIndex = 0;
    const conditionalPathsArray = [];
    const getConditionalPaths = (data, currentPath = '', localIndex = 0) => {
        currentPath = currentPath.replace(/^\.+|\.+$/g, '');
        const currentLocalIndex = localIndex;
        const currentData = lodash_1.default.get(data, currentPath);
        if (Array.isArray(currentData) && currentData.filter(Boolean).length > 0) {
            if (currentData.some(element => typeof element !== 'object')) {
                return;
            }
            const hasInnerDataArray = currentData.find(x => Array.isArray(x[conditionPaths[currentLocalIndex]]));
            if (hasInnerDataArray) {
                currentData.forEach((_, indexOutside) => {
                    const innerCompDataPath = `${currentPath}[${indexOutside}].${conditionPaths[currentLocalIndex]}`;
                    getConditionalPaths(data, innerCompDataPath, currentLocalIndex + 1);
                });
            }
            else {
                currentData.forEach((x, index) => {
                    if (!lodash_1.default.isNil(x[conditionPaths[currentLocalIndex]])) {
                        const compDataPath = `${currentPath}[${index}].${conditionPaths[currentLocalIndex]}`;
                        conditionalPathsArray.push(compDataPath);
                    }
                });
            }
        }
        else {
            if (!conditionPaths[currentGlobalIndex]) {
                return;
            }
            currentGlobalIndex = currentGlobalIndex + 1;
            getConditionalPaths(data, `${currentPath}.${conditionPaths[currentGlobalIndex - 1]}`, currentGlobalIndex);
        }
    };
    getConditionalPaths(data);
    return conditionalPathsArray;
}
/**
 *
 * @param component
 * @param condition
 * @param row
 * @param data
 * @param instance
 */
function checkSimpleConditional(component, condition, row, data, instance) {
    if (condition.when) {
        const value = getComponentActualValue(condition.when, data, row);
        const eq = String(condition.eq);
        const show = String(condition.show);
        // Special check for selectboxes component.
        if (lodash_1.default.isObject(value) && lodash_1.default.has(value, condition.eq)) {
            return String(value[condition.eq]) === show;
        }
        // FOR-179 - Check for multiple values.
        if (Array.isArray(value) && value.map(String).includes(eq)) {
            return show === 'true';
        }
        return (String(value) === eq) === (show === 'true');
    }
    else {
        const { conditions = [], conjunction = 'all', show = true } = condition;
        if (!conditions.length) {
            return true;
        }
        const conditionsResult = lodash_1.default.map(conditions, (cond) => {
            var _a, _b;
            const { value: comparedValue, operator, component: conditionComponentPath } = cond;
            if (!conditionComponentPath) {
                return true;
            }
            const splittedConditionPath = conditionComponentPath.split('.');
            const conditionalPaths = ((_a = instance === null || instance === void 0 ? void 0 : instance.parent) === null || _a === void 0 ? void 0 : _a.type) === 'datagrid' || ((_b = instance === null || instance === void 0 ? void 0 : instance.parent) === null || _b === void 0 ? void 0 : _b.type) === 'editgrid' ? [] : getConditionalPathsRecursive(splittedConditionPath, data);
            if (conditionalPaths.length > 0) {
                return conditionalPaths.map((path) => {
                    const value = getComponentActualValue(path, data, row);
                    const ConditionOperator = conditionOperators_1.default[operator];
                    return ConditionOperator
                        ? new ConditionOperator().getResult({ value, comparedValue, instance, component, path })
                        : true;
                });
            }
            else {
                const value = getComponentActualValue(conditionComponentPath, data, row);
                const СonditionOperator = conditionOperators_1.default[operator];
                return СonditionOperator
                    ? new СonditionOperator().getResult({ value, comparedValue, instance, component, path: conditionComponentPath })
                    : true;
            }
        });
        let result = false;
        switch (conjunction) {
            case 'any':
                result = lodash_1.default.some(conditionsResult.flat(), res => !!res);
                break;
            default:
                result = lodash_1.default.every(conditionsResult.flat(), res => !!res);
        }
        return show ? result : !result;
    }
}
exports.checkSimpleConditional = checkSimpleConditional;
/**
 * Returns a components normalized value.
 * @param {string} compPath - The full path to the component.
 * @param {*} data - The data object to get the value from.
 * @param {*} row - The contextual row data for the component.
 * @returns {*} - The normalized value of the component.
 */
function getComponentActualValue(compPath, data, row) {
    let value = null;
    if (data) {
        value = (0, formUtils_1.getValue)({ data }, compPath);
    }
    if (row && lodash_1.default.isNil(value)) {
        value = (0, formUtils_1.getValue)({ data: row }, compPath);
    }
    // FOR-400 - Fix issue where falsey values were being evaluated as show=true
    if (lodash_1.default.isNil(value) || (lodash_1.default.isObject(value) && lodash_1.default.isEmpty(value))) {
        value = '';
    }
    return value;
}
exports.getComponentActualValue = getComponentActualValue;
/**
 * Check custom javascript conditional.
 * @param {import('@ariform/core').Component} component - The component to check for the conditional.
 * @param {string} custom - The custom conditional string to evaluate.
 * @param {*} row - The row data for the component.
 * @param {*} data - The full submission data.
 * @param {import('@ariform/core').Form} form - The form object.
 * @param {string} variable - The variable name for the result of the custom conditional.
 * @param {*} onError - A custom return if there is an error or the value is null from the evaluation.
 * @param {import('../components/_classes/component/Component').Component} instance - The component instance.
 * @returns {*} - The result of the evaulation.
 */
function checkCustomConditional(component, custom, row, data, form, variable, onError, instance) {
    if (typeof custom === 'string') {
        custom = `var ${variable} = true; ${custom}; return ${variable};`;
    }
    const value = (instance && instance.evaluate) ?
        instance.evaluate(custom, { row, data, form }) :
        evaluate(custom, { row, data, form });
    if (value === null) {
        return onError;
    }
    return value;
}
exports.checkCustomConditional = checkCustomConditional;
/**
 * Check a component for JSON conditionals.
 * @param {import('@ariform/core').Component} component - The component
 * @param {import('@ariform/core').JSONConditional} json - The json conditional to check.
 * @param {*} row - The contextual row data for the component.
 * @param {*} data - The full submission data.
 * @param {import('@ariform/core').Form} form - The Form JSON of the form.
 * @param {*} onError - Custom return value if there is an error.
 * @returns {boolean} - TRUE if the condition is true; FALSE otherwise.
 */
function checkJsonConditional(component, json, row, data, form, onError) {
    try {
        return json_logic_js_1.default.apply(json, {
            data,
            row,
            form,
            _: lodash_1.default,
        });
    }
    catch (err) {
        console.warn(`An error occurred in jsonLogic advanced condition for ${component.key}`, err);
        return onError;
    }
}
exports.checkJsonConditional = checkJsonConditional;
/**
 * Returns the contextual row data for a component.
 * @param {import('@ariform/core').Component} component - The component to get the row data for.
 * @param {*} row - The row data for the component.
 * @param {import('../components/_classes/component/Component').Component} instance - The component instance.
 * @param {*} conditional - The component conditional.
 * @returns {*} - The contextual row data for the component.
 */
function getRow(component, row, instance, conditional) {
    var _a, _b, _c;
    const condition = conditional || component.conditional;
    // If no component's instance passed (happens only in 6.x server), calculate its path based on the schema
    if (!instance) {
        instance = lodash_1.default.cloneDeep(component);
    }
    const dataParent = getDataParentComponent(instance);
    if (dataParent) {
        const parentPath = (_a = dataParent.paths) === null || _a === void 0 ? void 0 : _a.localDataPath;
        const isTriggerCondtionComponentPath = condition.when || !condition.conditions
            ? (_b = condition.when) === null || _b === void 0 ? void 0 : _b.startsWith((_c = dataParent.paths) === null || _c === void 0 ? void 0 : _c.localPath)
            : lodash_1.default.some(condition.conditions, cond => { var _a; return cond.component.startsWith((_a = dataParent.paths) === null || _a === void 0 ? void 0 : _a.localPath); });
        if (isTriggerCondtionComponentPath) {
            const newRow = {};
            lodash_1.default.set(newRow, parentPath, row);
            row = newRow;
        }
    }
    return row;
}
/**
 * Checks the conditions for a provided component and data.
 * @param {import('@ariform/core').Component} component - The component to check for the condition.
 * @param {*} row - The data within a row
 * @param {*} data - The full submission data.
 * @param {import('@ariform/core').Form} form - The form object.
 * @param {import('../components/_classes/component/Component').Component} instance - The component instance.
 * @returns {boolean} - TRUE if the condition is true; FALSE otherwise.
 */
function checkCondition(component, row, data, form, instance) {
    const { customConditional, conditional, actionType } = component;
    if (actionType) {
        const action = (0, exports.getVariableTemp)('action');
        const actions = (0, exports.getVariableTemp)('actions');
        const checkAction = action && action === 'LIST' && actions ? JSON.parse(actions).find((value) => value.actionType === actionType)
            : action === actionType;
        if (!checkAction)
            return false;
    }
    if (customConditional) {
        return checkCustomConditional(component, customConditional, row, data, form, 'show', true, instance);
    }
    else if (conditional && (conditional.when || lodash_1.default.some(conditional.conditions || [], condition => condition.component && condition.operator))) {
        row = getRow(component, row, instance);
        return checkSimpleConditional(component, conditional, row, data, instance);
    }
    else if (conditional && conditional.json) {
        return checkJsonConditional(component, conditional.json, row, data, form, true);
    }
    // Default to show.
    return true;
}
exports.checkCondition = checkCondition;
/**
 * Test a trigger on a component.
 * @param {import('@ariform/core').Component} component - The component to test the trigger against.
 * @param {import('@ariform/core').LogicTrigger} trigger - The trigger configuration.
 * @param {import('@ariform/core').DataObject} row - The contextual row data.
 * @param {import('@ariform/core').DataObject} data - The root data object.
 * @param {import('@ariform/core').Form} form - The form object.
 * @param {any} instance - The component that is performing the trigger.
 * @returns {boolean} - TRUE if the trigger should fire; FALSE otherwise.
 */
function checkTrigger(component, trigger, row, data, form, instance) {
    // If trigger is empty, don't fire it
    if (!trigger || !trigger[trigger.type]) {
        return false;
    }
    switch (trigger.type) {
        case 'simple':
            row = getRow(component, row, instance, trigger.simple);
            return checkSimpleConditional(component, trigger.simple, row, data, instance);
        case 'javascript':
            return checkCustomConditional(component, trigger.javascript, row, data, form, 'result', false, instance);
        case 'json':
            return checkJsonConditional(component, trigger.json, row, data, form, false);
    }
    // If none of the types matched, don't fire the trigger.
    return false;
}
exports.checkTrigger = checkTrigger;
/**
 * Sets a property on a component via an executed Logic action.
 * @param {import('@ariform/core').Component} component - The component to set the property on.
 * @param {import('@ariform/core').LogicAction} action - The action to perform on the component.
 * @param {string} result - The name of the variable in the evaulation to use as the result.
 * @param {import('@ariform/core').DataObject} row - The contextual row data.
 * @param {import('@ariform/core').DataObject} data - The full submission data.
 * @param {any} instance - The component instance.
 * @returns {import('@ariform/core').Component} - The modified component.
 */
function setActionProperty(component, action, result, row, data, instance) {
    const property = action.property.value;
    switch (action.property.type) {
        case 'boolean': {
            const currentValue = lodash_1.default.get(component, property, false).toString();
            const newValue = action.state.toString();
            if (currentValue !== newValue) {
                lodash_1.default.set(component, property, newValue === 'true');
            }
            break;
        }
        case 'string': {
            const evalData = {
                data,
                row,
                component,
                result,
            };
            const textValue = action.property.component ? action[action.property.component] : action.text;
            const currentValue = lodash_1.default.get(component, property, '');
            const newValue = (instance && instance.interpolate)
                ? instance.interpolate(textValue, evalData)
                : Evaluator_1.Evaluator.interpolate(textValue, evalData);
            if (newValue !== currentValue) {
                lodash_1.default.set(component, property, newValue);
            }
            break;
        }
    }
    return component;
}
exports.setActionProperty = setActionProperty;
/**
 * Removes HTML tags from string e.g. <div>Hello World</div> => Hello World
 * @param {string} str - The string to remove HTML tags from.
 * @returns {string} - The string without HTML tags.
 */
function removeHTML(str) {
    const doc = new window.DOMParser().parseFromString(str, 'text/html');
    return (doc.body.textContent || '').trim();
}
exports.removeHTML = removeHTML;
/**
 * Unescape HTML characters like &lt, &gt, &amp and etc.
 * @param {string} str - The string to unescape.
 * @returns {string} - The unescaped string.
 */
function unescapeHTML(str) {
    if (typeof window === 'undefined' || !('DOMParser' in window)) {
        return str;
    }
    const elem = document.createElement('textarea');
    elem.innerHTML = str;
    return elem.value;
}
exports.unescapeHTML = unescapeHTML;
/**
 * Make HTML element from string
 * @param {string} str - The string to convert to an HTML element.
 * @param {string} selector - The selector to use to get the element once it is created.
 * @returns {HTMLElement} - The HTML element that was created.
 */
function convertStringToHTMLElement(str, selector) {
    const doc = new window.DOMParser().parseFromString(str, 'text/html');
    return doc.body.querySelector(selector);
}
exports.convertStringToHTMLElement = convertStringToHTMLElement;
/**
 * Make a filename guaranteed to be unique.
 * @param {string} name - The original name of the file.
 * @param {string} template - The template to use for the unique name.
 * @param {object} evalContext - The context to use for the evaluation.
 * @returns {string} - A unique filename.
 */
function uniqueName(name, template, evalContext) {
    template = template || '{{fileName}}-{{guid}}';
    //include guid in template anyway, to prevent overwriting issue if filename matches existing file
    if (!template.includes('{{guid}}')) {
        template = `${template}-{{guid}}`;
    }
    const parts = name.split('.');
    let fileName = parts.slice(0, parts.length - 1).join('.');
    const extension = parts.length > 1
        ? `.${lodash_1.default.last(parts)}`
        : '';
    //allow only 100 characters from original name to avoid issues with filename length restrictions
    fileName = fileName.substr(0, 100);
    evalContext = Object.assign(evalContext || {}, {
        fileName,
        guid: guid()
    });
    //only letters, numbers, dots, dashes, underscores and spaces are allowed. Anything else will be replaced with dash
    const uniqueName = `${Evaluator_1.Evaluator.interpolate(template, evalContext)}${extension}`.replace(/[^0-9a-zA-Z.\-_ ]/g, '-');
    return uniqueName;
}
exports.uniqueName = uniqueName;
/**
 * Returns a GUID
 * @returns {string} - A GUID.
 */
function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x'
            ? r
            : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
exports.guid = guid;
/**
 * Return a translated date setting.
 * @param {string|Date} date - The date to translate.
 * @returns {(null|Date)} - The translated date.
 */
function getDateSetting(date) {
    if (lodash_1.default.isNil(date) || lodash_1.default.isNaN(date) || date === '') {
        return null;
    }
    if (date instanceof Date) {
        return date;
    }
    else if (typeof date.toDate === 'function') {
        return date.isValid() ? date.toDate() : null;
    }
    let dateSetting = ((typeof date !== 'string') || (date.indexOf('moment(') === -1)) ? (0, moment_timezone_1.default)(date) : null;
    if (dateSetting && dateSetting.isValid()) {
        return dateSetting.toDate();
    }
    dateSetting = null;
    try {
        const value = Evaluator_1.Evaluator.evaluator(`return ${date};`, 'moment')(moment_timezone_1.default);
        if (typeof value === 'string') {
            dateSetting = (0, moment_timezone_1.default)(value);
        }
        else if (typeof value.toDate === 'function') {
            dateSetting = (0, moment_timezone_1.default)(value.toDate().toUTCString());
        }
        else if (value instanceof Date) {
            dateSetting = (0, moment_timezone_1.default)(value);
        }
    }
    catch (e) {
        return null;
    }
    if (!dateSetting) {
        return null;
    }
    // Ensure this is a date.
    if (!dateSetting.isValid()) {
        return null;
    }
    return dateSetting.toDate();
}
exports.getDateSetting = getDateSetting;
/**
 * Returns true if the date is a valid date. False otherwise.
 * @param {Date|string} date - The date to check for validity.
 * @returns {boolean} - TRUE if the date is valid; FALSE otherwise.
 */
function isValidDate(date) {
    return lodash_1.default.isDate(date) && !lodash_1.default.isNaN(date.getDate());
}
exports.isValidDate = isValidDate;
/**
 * Get the current timezone string.
 * @returns {string} - The current timezone.
 */
function currentTimezone() {
    if (moment_timezone_1.default.currentTimezone) {
        return moment_timezone_1.default.currentTimezone;
    }
    moment_timezone_1.default.currentTimezone = jstimezonedetect_1.default.determine().name();
    return moment_timezone_1.default.currentTimezone;
}
exports.currentTimezone = currentTimezone;
/**
 * Get an offset date provided a date object and timezone object.
 * @param {Date} date - The date to offset.
 * @param {string} timezone - The timezone to offset the date to.
 * @returns {Date} - The offset date.
 */
function offsetDate(date, timezone) {
    if (timezone === 'UTC') {
        return {
            date: new Date(date.getTime() + (date.getTimezoneOffset() * 60000)),
            abbr: 'UTC'
        };
    }
    const dateMoment = (0, moment_timezone_1.default)(date).tz(timezone);
    return {
        date: new Date(date.getTime() + ((dateMoment.utcOffset() + date.getTimezoneOffset()) * 60000)),
        abbr: dateMoment.format('z')
    };
}
exports.offsetDate = offsetDate;
/**
 * Returns if the zones are loaded.
 * @returns {boolean} - TRUE if the zones are loaded; FALSE otherwise.
 */
function zonesLoaded() {
    return moment_timezone_1.default.zonesLoaded;
}
exports.zonesLoaded = zonesLoaded;
/**
 * Returns if we should load the zones.
 * @param {string} timezone - The timezone to check if we should load the zones.
 * @returns {boolean} - TRUE if we should load the zones; FALSE otherwise.
 */
function shouldLoadZones(timezone) {
    if (timezone === currentTimezone() || timezone === 'UTC') {
        return false;
    }
    return true;
}
exports.shouldLoadZones = shouldLoadZones;
/**
 * Externally load the timezone data.
 * @param {string} url - The URL to load the timezone data from.
 * @param {string} timezone - The timezone to load.
 * @returns {Promise<any> | *} - Resolves when the zones for this timezone are loaded.
 */
function loadZones(url, timezone) {
    if (timezone && !shouldLoadZones(timezone)) {
        // Return non-resolving promise.
        return new Promise(lodash_1.default.noop);
    }
    if (moment_timezone_1.default.zonesPromise) {
        return moment_timezone_1.default.zonesPromise;
    }
    return moment_timezone_1.default.zonesPromise = fetch(url)
        .then(resp => resp.json().then(zones => {
        moment_timezone_1.default.tz.load(zones);
        moment_timezone_1.default.zonesLoaded = true;
        // Trigger a global event that the timezones have finished loading.
        if (document && document.createEvent && document.body && document.body.dispatchEvent) {
            var event = document.createEvent('Event');
            event.initEvent('zonesLoaded', true, true);
            document.body.dispatchEvent(event);
        }
    }));
}
exports.loadZones = loadZones;
/**
 * Get the moment date object for translating dates with timezones.
 * @param {string|Date} value - The value to convert into a moment date.
 * @param {string} format - The format to convert the date to.
 * @param {string} timezone - The timezone to convert the date to.
 * @returns {Date} - The moment date object.
 */
function momentDate(value, format, timezone) {
    const momentDate = (0, moment_timezone_1.default)(value);
    if (!timezone) {
        return momentDate;
    }
    if (timezone === 'UTC') {
        timezone = 'Etc/UTC';
    }
    if ((timezone !== currentTimezone() || (format && format.match(/\s(z$|z\s)/))) && moment_timezone_1.default.zonesLoaded) {
        return momentDate.tz(timezone);
    }
    return momentDate;
}
exports.momentDate = momentDate;
/**
 * Format a date provided a value, format, and timezone object.
 * @param {string} timezonesUrl - The URL to load the timezone data from.
 * @param {string|Date} value - The value to format.
 * @param {string} format - The format to format the date to.
 * @param {string} timezone - The timezone to format the date to.
 * @param {string} flatPickrInputFormat - The format to use for flatpickr input.
 * @returns {string} - The formatted date.
 */
function formatDate(timezonesUrl, value, format, timezone, flatPickrInputFormat) {
    const momentDate = (0, moment_timezone_1.default)(value, flatPickrInputFormat || undefined);
    if (timezone === currentTimezone()) {
        // See if our format contains a "z" timezone character.
        if (format.match(/\s(z$|z\s)/)) {
            loadZones(timezonesUrl);
            if (moment_timezone_1.default.zonesLoaded) {
                return momentDate.tz(timezone).format(convertFormatToMoment(format));
            }
            else {
                return momentDate.format(convertFormatToMoment(format.replace(/\s(z$|z\s)/, '')));
            }
        }
        // Return the standard format.
        return momentDate.format(convertFormatToMoment(format));
    }
    if (timezone === 'UTC') {
        const offset = offsetDate(momentDate.toDate(), 'UTC');
        return `${(0, moment_timezone_1.default)(offset.date).format(convertFormatToMoment(format))} UTC`;
    }
    // Load the zones since we need timezone information.
    loadZones(timezonesUrl);
    if (moment_timezone_1.default.zonesLoaded && timezone) {
        return momentDate.tz(timezone).format(`${convertFormatToMoment(format)} z`);
    }
    else {
        return momentDate.format(convertFormatToMoment(format));
    }
}
exports.formatDate = formatDate;
/**
 * Pass a format function to format within a timezone.
 * @param {string} timezonesUrl - The URL to load the timezone data from.
 * @param {Function} formatFn - The format function to use.
 * @param {Date|string} date - The date to format.
 * @param {string} format - The format to format the date to.
 * @param {string} timezone - The timezone to format the date to.
 * @returns {string} - The formatted date.
 */
function formatOffset(timezonesUrl, formatFn, date, format, timezone) {
    if (timezone === currentTimezone()) {
        return formatFn(date, format);
    }
    if (timezone === 'UTC') {
        return `${formatFn(offsetDate(date, 'UTC').date, format)} UTC`;
    }
    // Load the zones since we need timezone information.
    loadZones(timezonesUrl);
    if (moment_timezone_1.default.zonesLoaded) {
        const offset = offsetDate(date, timezone);
        return `${formatFn(offset.date, format)} ${offset.abbr}`;
    }
    else {
        return formatFn(date, format);
    }
}
exports.formatOffset = formatOffset;
/**
 * Returns the local date format information.
 * @param {Intl.LocalesArgument} locale - The locale to get the date format for.
 * @returns {object} - The local date format information.
 */
function getLocaleDateFormatInfo(locale) {
    const formatInfo = {};
    const day = 21;
    const exampleDate = new Date(2017, 11, day);
    const localDateString = exampleDate.toLocaleDateString(locale);
    formatInfo.dayFirst = localDateString.slice(0, 2) === day.toString();
    return formatInfo;
}
exports.getLocaleDateFormatInfo = getLocaleDateFormatInfo;
/**
 * Convert the format from the angular-datepicker module to flatpickr format.
 * @param {string} format - The format to convert.
 * @returns {string} - The converted format.
 */
function convertFormatToFlatpickr(format) {
    return format
        // Remove the Z timezone offset, not supported by flatpickr.
        .replace(/Z/g, '')
        // Year conversion.
        .replace(/y/g, 'Y')
        .replace('YYYY', 'Y')
        .replace('YY', 'y')
        // Month conversion.
        .replace('MMMM', 'F')
        .replace(/M/g, 'n')
        .replace('nnn', 'M')
        .replace('nn', 'm')
        // Day in month.
        .replace(/d/g, 'j')
        .replace(/jj/g, 'd')
        // Day in week.
        .replace('EEEE', 'l')
        .replace('EEE', 'D')
        // Hours, minutes, seconds
        .replace('HH', 'H')
        .replace('hh', 'G')
        .replace('mm', 'i')
        .replace('ss', 'S')
        .replace(/a/g, 'K');
}
exports.convertFormatToFlatpickr = convertFormatToFlatpickr;
/**
 * Convert the format from the angular-datepicker module to moment format.
 * @param {string} format - The format to convert.
 * @returns {string} - The converted format.
 */
function convertFormatToMoment(format) {
    return format
        // Year conversion.
        .replace(/y/g, 'Y')
        // Day in month.
        .replace(/d/g, 'D')
        // Day in week.
        .replace(/E/g, 'd')
        // AM/PM marker
        .replace(/a/g, 'A')
        // Unix Timestamp
        .replace(/U/g, 'X');
}
exports.convertFormatToMoment = convertFormatToMoment;
/**
 * Convert the format from the angular-datepicker module to mask format.
 * @param {string} format - The format to convert.
 * @returns {string} - The converted format.
 */
function convertFormatToMask(format) {
    return format
        // Long month replacement.
        .replace(/M{4}/g, 'MM')
        // Initial short month conversion.
        .replace(/M{3}/g, '***')
        // Short month conversion if input as text.
        .replace(/e/g, 'Q')
        // Month number conversion.
        .replace(/W/g, '99')
        // Year conversion.
        .replace(/[ydhmswHMG]/g, '9')
        // AM/PM conversion.
        .replace(/a/g, 'AA');
}
exports.convertFormatToMask = convertFormatToMask;
/**
 * Returns an input mask that is compatible with the input mask library.
 * @param {string} mask - The Ari.Form input mask.
 * @param {string} placeholderChar - Char which is used as a placeholder.
 * @returns {Array} - The input mask for the mask library.
 */
function getInputMask(mask, placeholderChar) {
    if (mask instanceof Array) {
        return mask;
    }
    const maskArray = [];
    maskArray.numeric = true;
    for (let i = 0; i < mask.length; i++) {
        switch (mask[i]) {
            case '9':
                maskArray.push(/\d/);
                break;
            case 'A':
                maskArray.numeric = false;
                maskArray.push(/[a-zA-Z]/);
                break;
            case 'a':
                maskArray.numeric = false;
                maskArray.push(/[a-z]/);
                break;
            case '*':
                maskArray.numeric = false;
                maskArray.push(/[a-zA-Z0-9]/);
                break;
            // If char which is used inside mask placeholder was used in the mask, replace it with space to prevent errors
            case placeholderChar:
                maskArray.numeric = false;
                maskArray.push(' ');
                break;
            default:
                maskArray.numeric = false;
                maskArray.push(mask[i]);
                break;
        }
    }
    return maskArray;
}
exports.getInputMask = getInputMask;
/**
 * Unmasks a value using the provided mask and placeholder characters.
 * @param {string} value - The value to unmask.
 * @param {string} mask - The mask to use for unmasking.
 * @param {string} placeholderChar - The placeholder character to use for unmasking.
 * @returns {string} - The unmasked value.
 */
function unmaskValue(value, mask, placeholderChar) {
    if (!mask || !value || value.length > mask.length) {
        return value;
    }
    let unmaskedValue = value.split('');
    for (let i = 0; i < mask.length; i++) {
        const char = value[i] || '';
        const charPart = mask[i];
        if (!lodash_1.default.isRegExp(charPart) && char === charPart) {
            unmaskedValue[i] = '';
        }
    }
    unmaskedValue = unmaskedValue.join('').replace(placeholderChar, '');
    return unmaskedValue;
}
exports.unmaskValue = unmaskValue;
/**
 * Returns true if the value matches the input mask format.
 * @param {string} value - The value to check.
 * @param {string} inputMask - The input mask to check against.
 * @returns {boolean} - TRUE if the value matches the input mask; FALSE otherwise.
 */
function matchInputMask(value, inputMask) {
    if (!inputMask) {
        return true;
    }
    // If value is longer than mask, it isn't valid.
    if (value.length > inputMask.length) {
        return false;
    }
    for (let i = 0; i < inputMask.length; i++) {
        const char = value[i] || '';
        const charPart = inputMask[i];
        if (!(lodash_1.default.isRegExp(charPart) && charPart.test(char) || charPart === char)) {
            return false;
        }
    }
    return true;
}
exports.matchInputMask = matchInputMask;
/**
 * Returns the number separators (i.e. 1,000) for the provided language.
 * @param {string} lang - The language code to get the number separators for.
 * @returns {{delimiter: string, decimalSeparator: string}} - The number separators.
 */
function getNumberSeparators(lang = 'en') {
    const formattedNumberString = (12345.6789).toLocaleString(lang);
    const delimeters = formattedNumberString.match(/..(.)...(.)../);
    if (!delimeters) {
        return {
            delimiter: ',',
            decimalSeparator: '.'
        };
    }
    return {
        delimiter: (delimeters.length > 1) ? delimeters[1] : ',',
        decimalSeparator: (delimeters.length > 2) ? delimeters[2] : '.',
    };
}
exports.getNumberSeparators = getNumberSeparators;
/**
 * Returns the number for the maximum amount of decimal places for a number.
 * @param {import('@ariform/core').Component} component - The component to check for decimal limits.
 * @param {number} defaultLimit - The default limit to use if none is provided in the component.
 * @returns {number} - The number of decimal places allowed.
 */
function getNumberDecimalLimit(component, defaultLimit) {
    if (lodash_1.default.has(component, 'decimalLimit')) {
        return lodash_1.default.get(component, 'decimalLimit');
    }
    // Determine the decimal limit. Defaults to 20 but can be overridden by validate.step or decimalLimit settings.
    let decimalLimit = defaultLimit || 20;
    const step = lodash_1.default.get(component, 'validate.step', 'any');
    if (step !== 'any') {
        const parts = step.toString().split('.');
        if (parts.length > 1) {
            decimalLimit = parts[1].length;
        }
    }
    return decimalLimit;
}
exports.getNumberDecimalLimit = getNumberDecimalLimit;
/**
 * Returns the currency affixes for a specific language.
 * @param {object} arg0 - The arguments object.
 * @param {string} arg0.currency - The currency code to get the affixes for.
 * @param {number} arg0.decimalLimit - The number of decimal places to use.
 * @param {string} arg0.decimalSeparator - The decimal separator to use.
 * @param {string} arg0.lang - The language code to use.
 * @returns {{prefix: string, suffix: string}} - The currency affixes.
 */
function getCurrencyAffixes({ currency, decimalLimit, decimalSeparator, lang, }) {
    // Get the prefix and suffix from the localized string.
    // hungnq 
    if (lang === "vi-VN") {
        // Vietnamese locale uses a different format for currency.
        lang = 'vn';
    }
    // end hungnq
    let regex = `(.*)?${(100).toLocaleString(lang)}`;
    if (decimalLimit) {
        regex += `${decimalSeparator === '.' ? '\\.' : decimalSeparator}${(0).toLocaleString(lang)}{${decimalLimit}}`;
    }
    regex += '(.*)?';
    const parts = (100).toLocaleString(lang, {
        style: 'currency',
        currency: currency ? currency : 'LAK',
        useGrouping: true,
        maximumFractionDigits: decimalLimit || 0,
        minimumFractionDigits: decimalLimit || 0
    }).replace('.', decimalSeparator).match(new RegExp(regex));
    return {
        prefix: (parts === null || parts === void 0 ? void 0 : parts[1]) || '',
        suffix: (parts === null || parts === void 0 ? void 0 : parts[2]) || ''
    };
}
exports.getCurrencyAffixes = getCurrencyAffixes;
/**
 * Fetch the field data provided a component.
 * @param {import('@ariform/core').DataObject} data - The data object to fetch the field data from.
 * @param {import('@ariform/core').Component} component - The component to fetch the field data for.
 * @returns {*} - The field data.
 */
function fieldData(data, component) {
    if (!data) {
        return '';
    }
    if (!component || !component.key) {
        return data;
    }
    if (component.key.includes('.')) {
        let value = data;
        const parts = component.key.split('.');
        let key = '';
        for (let i = 0; i < parts.length; i++) {
            key = parts[i];
            // Handle nested resources
            if (value.hasOwnProperty('_id')) {
                value = value.data;
            }
            // Return if the key is not found on the value.
            if (!value.hasOwnProperty(key)) {
                return;
            }
            // Convert old single field data in submissions to multiple
            if (key === parts[parts.length - 1] && component.multiple && !Array.isArray(value[key])) {
                value[key] = [value[key]];
            }
            // Set the value of this key.
            value = value[key];
        }
        return value;
    }
    else {
        // Convert old single field data in submissions to multiple
        if (component.multiple && !Array.isArray(data[component.key])) {
            data[component.key] = [data[component.key]];
        }
        // Fix for checkbox type radio submission values in tableView
        if (component.type === 'checkbox' && component.inputType === 'radio') {
            return data[component.name] === component.value;
        }
        return data[component.key];
    }
}
exports.fieldData = fieldData;
/**
 * Delays function execution with possibility to execute function synchronously or cancel it.
 * @param {Function} fn - Function to delay
 * @param {number} delay - Delay time
 * @param {...any} args - Arguments to pass to the function
 * @returns {*} - Function to cancel the delay
 */
function delay(fn, delay = 0, ...args) {
    const timer = setTimeout(fn, delay, ...args);
    /**
     *
     */
    function cancel() {
        clearTimeout(timer);
    }
    /**
     * Execute the function early.
     * @returns {*} - The result of the function.
     */
    function earlyCall() {
        cancel();
        return fn(...args);
    }
    earlyCall.timer = timer;
    earlyCall.cancel = cancel;
    return earlyCall;
}
exports.delay = delay;
/**
 * Iterate the given key to make it unique.
 * @param {string} key
 *   Modify the component key to be unique.
 * @returns {string}
 *   The new component key.
 */
function iterateKey(key) {
    if (!key.match(/(\d+)$/)) {
        return `${key}1`;
    }
    return key.replace(/(\d+)$/, function (suffix) {
        return Number(suffix) + 1;
    });
}
exports.iterateKey = iterateKey;
/**
 * Determines a unique key within a map provided the base key.
 * @param {Record<string, string>} map - The map to check for uniqueness.
 * @param {string} base - The base path of the key.
 * @returns {string} - The unique key.
 */
function uniqueKey(map, base) {
    let newKey = base;
    while (map.hasOwnProperty(newKey)) {
        newKey = iterateKey(newKey);
    }
    return newKey;
}
exports.uniqueKey = uniqueKey;
/**
 * Determines the major version number of bootstrap.
 * @param {object} options - The options to check for bootstrap version.
 * @param {string} options.bootstrap - The bootstrap version to use.
 * @returns {number} - The bootstrap version.
 */
function bootstrapVersion(options) {
    if (options.bootstrap) {
        return options.bootstrap;
    }
    if ((typeof jQuery === 'function') && (typeof jQuery().collapse === 'function')) {
        return parseInt(jQuery.fn.collapse.Constructor.VERSION.split('.')[0], 10);
    }
    if (window.bootstrap && window.bootstrap.Collapse) {
        return parseInt(window.bootstrap.Collapse.VERSION.split('.')[0], 10);
    }
    return 0;
}
exports.bootstrapVersion = bootstrapVersion;
/**
 * Retrun provided argument.
 * If argument is a function, returns the result of a function call.
 * @param {Function|any} e - The argument to check if a function and call if so.
 * @returns {any} - Either the result of the function call (e) or e if it is not a function.
 */
function unfold(e) {
    if (typeof e === 'function') {
        return e();
    }
    return e;
}
exports.unfold = unfold;
/**
 * Map values through unfold and return first non-nil value.
 * @param {Array<T>} collection - The collection to map through unfold.;
 * @returns {T} - The first non-nil value.
 */
exports.firstNonNil = lodash_1.default.flow([
    lodash_1.default.partialRight(lodash_1.default.map, unfold),
    lodash_1.default.partialRight(lodash_1.default.find, v => !lodash_1.default.isUndefined(v))
]);
/**
 * Create enclosed state. Returns functions to getting and cycling between states.
 * @param {*} a - initial state.
 * @param {*} b - next state.
 * @returns {Functions[]} -- [get, toggle];
 */
function withSwitch(a, b) {
    let state = a;
    let next = b;
    /**
     * Returns the state of the switch.
     * @returns {*} - The current state.
     */
    function get() {
        return state;
    }
    /**
     * Toggles the state of the switch.
     */
    function toggle() {
        const prev = state;
        state = next;
        next = prev;
    }
    return [get, toggle];
}
exports.withSwitch = withSwitch;
/**
 * Create a function that will call the provided function only the provided limit.
 * @param {Function} callback - The callback to call.
 * @param {object} options - The options to use.
 * @param {number} options.limit - The limit to call the callback.
 * @param {number} options.delay - The delay to wait before resetting the call count.
 * @returns {Function} - The function that will call the callback only the provided limit.
 */
function observeOverload(callback, options = {}) {
    const { limit = 50, delay = 500 } = options;
    let callCount = 0;
    let timeoutID = 0;
    const reset = () => callCount = 0;
    return () => {
        if (timeoutID !== 0) {
            clearTimeout(timeoutID);
            timeoutID = 0;
        }
        timeoutID = setTimeout(reset, delay);
        callCount += 1;
        if (callCount >= limit) {
            clearTimeout(timeoutID);
            reset();
            return callback();
        }
    };
}
exports.observeOverload = observeOverload;
/**
 * Returns the components that are provided within an evaluation context.
 * @param {any} context - The evaluation context to get the components from.
 * @param {boolean} excludeNested - Exclude nested components.
 * @param {Array<string>} excludedTypes - The types of components to exclude.
 * @returns {Array} - The components within the evaluation context.
 */
function getContextComponents(context, excludeNested, excludedTypes = []) {
    const values = [];
    context.utils.eachComponent(context.instance.options.editForm.components, (component, path) => {
        const addToContextComponents = excludeNested ? !component.tree : true;
        if (component.key !== context.data.key && addToContextComponents && !lodash_1.default.includes(excludedTypes, component.type)) {
            values.push({
                label: `${component.label || component.key} (${path})`,
                value: path,
            });
        }
    });
    return values;
}
exports.getContextComponents = getContextComponents;
/**
 * Returns the button components that are within an evaluation context.
 * @param {any} context - The evaluation context to get the components from.
 * @returns {Array} - The button components within the evaluation context.
 */
function getContextButtons(context) {
    const values = [];
    context.utils.eachComponent(context.instance.options.editForm.components, (component) => {
        if (component.type === 'button') {
            values.push({
                label: `${component.key} (${component.label})`,
                value: component.key,
            });
        }
    });
    return values;
}
exports.getContextButtons = getContextButtons;
// Tags that could be in text, that should be ommited or handled in a special way
const inTextTags = ['#text', 'A', 'B', 'EM', 'I', 'SMALL', 'STRONG', 'SUB', 'SUP', 'INS', 'DEL', 'MARK', 'CODE'];
/**
 * Helper function for 'translateHTMLTemplate'. Translates text value of the passed html element.
 * @param {HTMLElement} elem - The element to translate.
 * @param {Function} translate - The translation function.
 * @returns {string} - Translated element template.
 */
function translateElemValue(elem, translate) {
    if (!elem.innerText) {
        return elem.innerHTML;
    }
    const elemValue = elem.innerText.replace(Evaluator_1.Evaluator.templateSettings.interpolate, '').replace(/\s\s+/g, ' ').trim();
    const translatedValue = translate(elemValue);
    if (elemValue !== translatedValue) {
        const links = elem.innerHTML.match(/<a[^>]*>(.*?)<\/a>/g);
        if (links && links.length) {
            if (links.length === 1 && links[0].length === elem.innerHTML.length) {
                return elem.innerHTML.replace(elemValue, translatedValue);
            }
            const translatedLinks = links.map(link => {
                const linkElem = document.createElement('a');
                linkElem.innerHTML = link;
                return translateElemValue(linkElem, translate);
            });
            return `${translatedValue} (${translatedLinks.join(', ')})`;
        }
        else {
            return elem.innerText.replace(elemValue, translatedValue);
        }
    }
    else {
        return elem.innerHTML;
    }
}
/**
 * Helper function for 'translateHTMLTemplate'. Goes deep through html tag children and calls function to translate their text values.
 * @param {HTMLElement} tag - The tag to translate.
 * @param {Function} translate - The translation function.
 * @returns {void}
 */
function translateDeepTag(tag, translate) {
    const children = tag.children.length && [...tag.children];
    const shouldTranslateEntireContent = children && children.every(child => child.children.length === 0
        && inTextTags.some(tag => child.nodeName === tag));
    if (!children || shouldTranslateEntireContent) {
        tag.innerHTML = translateElemValue(tag, translate);
    }
    else {
        children.forEach(child => translateDeepTag(child, translate));
    }
}
/**
 * Translates text values in html template.
 * @param {string} template - The template to translate.
 * @param {Function} translate - The translation function.
 * @returns {string} - Html template with translated values.
 */
function translateHTMLTemplate(template, translate) {
    const isHTML = /<[^>]*>/.test(template);
    if (!isHTML) {
        return translate(template);
    }
    const tempElem = document.createElement('div');
    tempElem.innerHTML = template;
    if (tempElem.innerText && tempElem.children.length) {
        translateDeepTag(tempElem, translate);
        return tempElem.innerHTML;
    }
    return template;
}
exports.translateHTMLTemplate = translateHTMLTemplate;
/**
 * Sanitize an html string.
 * @param {string} string - The string to sanitize.
 * @param {any} options - The options to use for sanitization.
 * @returns {string} - The sanitized html string.
 */
function sanitize(string, options) {
    if (typeof dompurify_1.default.sanitize !== 'function') {
        return string;
    }
    // Dompurify configuration
    const sanitizeOptions = {
        ADD_ATTR: ['ref', 'target'],
        USE_PROFILES: { html: true }
    };
    // Use profiles
    if (options.sanitizeConfig && options.sanitizeConfig.useProfiles) {
        Object.keys(options.sanitizeConfig.useProfiles).forEach(key => {
            sanitizeOptions.USE_PROFILES[key] = options.sanitizeConfig.useProfiles[key];
        });
    }
    // Add attrs
    if (options.sanitizeConfig && Array.isArray(options.sanitizeConfig.addAttr) && options.sanitizeConfig.addAttr.length > 0) {
        options.sanitizeConfig.addAttr.forEach((attr) => {
            sanitizeOptions.ADD_ATTR.push(attr);
        });
    }
    // Add tags
    if (options.sanitizeConfig && Array.isArray(options.sanitizeConfig.addTags) && options.sanitizeConfig.addTags.length > 0) {
        sanitizeOptions.ADD_TAGS = options.sanitizeConfig.addTags;
    }
    // Allow tags
    if (options.sanitizeConfig && Array.isArray(options.sanitizeConfig.allowedTags) && options.sanitizeConfig.allowedTags.length > 0) {
        sanitizeOptions.ALLOWED_TAGS = options.sanitizeConfig.allowedTags;
    }
    // Allow attributes
    if (options.sanitizeConfig && Array.isArray(options.sanitizeConfig.allowedAttrs) && options.sanitizeConfig.allowedAttrs.length > 0) {
        sanitizeOptions.ALLOWED_ATTR = options.sanitizeConfig.allowedAttrs;
    }
    // Allowd URI Regex
    if (options.sanitizeConfig && options.sanitizeConfig.allowedUriRegex) {
        const allowedUriRegex = options.sanitizeConfig.allowedUriRegex;
        sanitizeOptions.ALLOWED_URI_REGEXP = lodash_1.default.isString(allowedUriRegex) ? new RegExp(allowedUriRegex) : allowedUriRegex;
    }
    // Allow to extend the existing array of elements that are safe for URI-like values
    if (options.sanitizeConfig && Array.isArray(options.sanitizeConfig.addUriSafeAttr) && options.sanitizeConfig.addUriSafeAttr.length > 0) {
        sanitizeOptions.ADD_URI_SAFE_ATTR = options.sanitizeConfig.addUriSafeAttr;
    }
    return dompurify_1.default.sanitize(string, sanitizeOptions);
}
exports.sanitize = sanitize;
/**
 * Fast cloneDeep for JSON objects only.
 * @param {any} obj - The object to perform a fast clone deep against.
 * @returns {any} - The cloned object.
 */
function fastCloneDeep(obj) {
    return obj ? JSON.parse(JSON.stringify(obj)) : obj;
}
exports.fastCloneDeep = fastCloneDeep;
/**
 * Returns if the component is an input component.
 * @param {import('@ariform/core').Component} componentJson - The JSON of a component.
 * @returns {bool} - TRUE if the component is an input component; FALSE otherwise.
 */
function isInputComponent(componentJson) {
    if (componentJson.input === false || componentJson.input === true) {
        return componentJson.input;
    }
    switch (componentJson.type) {
        case 'htmlelement':
        case 'content':
        case 'columns':
        case 'fieldset':
        case 'panel':
        case 'table':
        case 'tabs':
        case 'well':
        case 'button':
            return false;
        default:
            return true;
    }
}
exports.isInputComponent = isInputComponent;
/**
 * Takes a component path, and returns a component path array.
 * @param {string} pathStr - The path string to convert to an array.
 * @returns {Arryay<number>} - The array of paths.
 */
function getArrayFromComponentPath(pathStr) {
    if (!pathStr || !lodash_1.default.isString(pathStr)) {
        if (!lodash_1.default.isArray(pathStr)) {
            return [pathStr];
        }
        return pathStr;
    }
    return pathStr.replace(/[[\]]/g, '.')
        .replace(/\.\./g, '.')
        .replace(/(^\.)|(\.$)/g, '')
        .split('.')
        .map(part => lodash_1.default.defaultTo(lodash_1.default.toNumber(part), part));
}
exports.getArrayFromComponentPath = getArrayFromComponentPath;
/**
 * Returns true if the component is a child of the parent.
 * @param {any} child - The child component to check.
 * @param {any} parent - The parent component to check.
 * @returns {boolean} - TRUE if the child is a child of the parent; FALSE otherwise.
 */
function isChildOf(child, parent) {
    while (child && child.parent) {
        if (child.parent === parent) {
            return true;
        }
        child = child.parent;
    }
    return false;
}
exports.isChildOf = isChildOf;
/**
 * Takes an array of component path indexes, and returns a string version of that array.
 * @param {Array<number>} path - The path array to convert to a string.
 * @returns {string} - The string version of the path.
 */
function getStringFromComponentPath(path) {
    if (!lodash_1.default.isArray(path)) {
        return path;
    }
    let strPath = '';
    path.forEach((part, i) => {
        if (lodash_1.default.isNumber(part)) {
            strPath += `[${part}]`;
        }
        else {
            strPath += i === 0 ? part : `.${part}`;
        }
    });
    return strPath;
}
exports.getStringFromComponentPath = getStringFromComponentPath;
/**
 * Takes a number and rounds it to the provided precision amount.
 * @param {number} number - The number to round.
 * @param {number} precision - The precision to round the number to.
 * @returns {string} - The rounded number.
 */
function round(number, precision) {
    if (lodash_1.default.isNumber(number)) {
        return number.toFixed(precision);
    }
    return number.toString();
}
exports.round = round;
/**
 * Check for Internet Explorer browser version
 * @returns {(number|null)} - The IE browser version or null if not IE
 */
function getIEBrowserVersion() {
    const { ie, version } = getBrowserInfo();
    return ie ? version : null;
}
exports.getIEBrowserVersion = getIEBrowserVersion;
/**
 * Get browser name and version (modified from 'jquery-browser-plugin')
 * @returns {object} -- {{browser name, version, isWebkit?}}
 * Possible browser names: chrome, safari, ie, edge, opera, mozilla, yabrowser
 */
function getBrowserInfo() {
    const browser = {};
    if (typeof window === 'undefined') {
        return browser;
    }
    const ua = window.navigator.userAgent.toLowerCase();
    const match = /(edge|edg)\/([\w.]+)/.exec(ua) ||
        /(opr)[/]([\w.]+)/.exec(ua) ||
        /(yabrowser)[ /]([\w.]+)/.exec(ua) ||
        /(chrome)[ /]([\w.]+)/.exec(ua) ||
        /(iemobile)[/]([\w.]+)/.exec(ua) ||
        /(version)(applewebkit)[ /]([\w.]+).*(safari)[ /]([\w.]+)/.exec(ua) ||
        /(webkit)[ /]([\w.]+).*(version)[ /]([\w.]+).*(safari)[ /]([\w.]+)/.exec(ua) ||
        /(webkit)[ /]([\w.]+)/.exec(ua) ||
        /(opera)(?:.*version|)[ /]([\w.]+)/.exec(ua) ||
        /(msie) ([\w.]+)/.exec(ua) ||
        ua.indexOf('trident') >= 0 && /(rv)(?::| )([\w.]+)/.exec(ua) ||
        ua.indexOf('compatible') < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) ||
        [];
    const matched = {
        browser: match[5] || match[3] || match[1] || '',
        version: match[4] || match[2] || '0'
    };
    if (matched.browser) {
        browser[matched.browser] = true;
        browser.version = parseInt(matched.version, 10);
    }
    // Chrome, Opera 15+, Safari and Yandex.Browser are webkit based browsers
    if (browser.chrome || browser.opr || browser.safari || browser.edg || browser.yabrowser) {
        browser.isWebkit = true;
    }
    // IE11 has a new token so we will assign it ie to avoid breaking changes
    if (browser.rv || browser.iemobile) {
        browser.ie = true;
    }
    // Edge has a new token since it became webkit based
    if (browser.edg) {
        browser.edge = true;
    }
    // Opera 15+ are identified as opr
    if (browser.opr) {
        browser.opera = true;
    }
    return browser;
}
exports.getBrowserInfo = getBrowserInfo;
/**
 * Takes a component path, which may include array indicies (i.e. [0][1]), and returns the compoennt path without the indicies.
 * @param {string} path - The path to remove the indicies from.
 * @returns {string} - The path without the indicies.
 */
function getComponentPathWithoutIndicies(path = '') {
    return path.replace(/\[\d+\]/, '');
}
exports.getComponentPathWithoutIndicies = getComponentPathWithoutIndicies;
/**
 * Returns a path to the component which based on its schema
 * @param {import('@ariform/core').Component} component - Component containing link to its parent's schema in the 'parent' property
 * @returns {string} - Path to the component
 */
function getComponentPath(component) {
    return component.paths.localDataPath;
}
exports.getComponentPath = getComponentPath;
/**
 * Returns a parent component of the passed component instance skipping all the Layout components
 * @param {Component} componentInstance - The component to check for the parent.
 * @returns {Component|undefined} - The parent data component.
 */
function getDataParentComponent(componentInstance) {
    if (!componentInstance) {
        return;
    }
    const { parent } = componentInstance;
    if (parent && (parent.isInputComponent || parent.input)) {
        return parent;
    }
    else {
        return getDataParentComponent(parent);
    }
}
exports.getDataParentComponent = getDataParentComponent;
/**
 * Returns whether the value is a promise
 * @param {any} value - The value to check
 * @returns {boolean} - TRUE if the value is a promise; FALSE otherwise
 */
function isPromise(value) {
    return value
        && value.then
        && typeof value.then === 'function'
        && Object.prototype.toString.call(value) === '[object Promise]';
}
exports.isPromise = isPromise;
/**
 * Determines if the component has a scoping parent in tree (a component which scopes its children and manages its
 * changes by itself, e.g. EditGrid)
 * @param {Component} componentInstance - The component to check for the scoping parent.
 * @param {boolean} firstPass - Whether it is the first pass of the function
 * @returns {boolean|*} - TRUE if the component has a scoping parent; FALSE otherwise
 */
function isInsideScopingComponent(componentInstance, firstPass = true) {
    if (!firstPass && (componentInstance === null || componentInstance === void 0 ? void 0 : componentInstance.hasScopedChildren)) {
        return true;
    }
    const dataParent = getDataParentComponent(componentInstance);
    if (dataParent === null || dataParent === void 0 ? void 0 : dataParent.hasScopedChildren) {
        return true;
    }
    else if (dataParent === null || dataParent === void 0 ? void 0 : dataParent.parent) {
        return isInsideScopingComponent(dataParent.parent, false);
    }
    return false;
}
exports.isInsideScopingComponent = isInsideScopingComponent;
/**
 * Returns all the focusable elements within the provided dom element.
 * @param {HTMLElement} element - The element to get the focusable elements from.
 * @returns {NodeList<HTMLElement>} - The focusable elements within the provided element.
 */
function getFocusableElements(element) {
    const focusableSelector = `button:not([disabled]), input:not([disabled]), select:not([disabled]),
    textarea:not([disabled]), button:not([disabled]), [href]`;
    return element.querySelectorAll(focusableSelector);
}
exports.getFocusableElements = getFocusableElements;
exports.componentValueTypes = {
    number: 'number',
    string: 'string',
    boolean: 'boolean',
    array: 'array',
    object: 'object',
    date: 'date',
    any: 'any',
};
/**
 * Returns the saved types for the component
 * @param {import('@ariform/core').Component} fullSchema - The component schema
 * @returns {Array<string>|null} - The saved types for the component
 */
function getComponentSavedTypes(fullSchema) {
    const schema = fullSchema || {};
    if (schema.persistent !== true) {
        return [];
    }
    if (schema.multiple) {
        return [exports.componentValueTypes.array];
    }
    return null;
}
exports.getComponentSavedTypes = getComponentSavedTypes;
/**
 * Interpolates @ariform/core errors so that they are compatible with the renderer
 * @param {Component} component - The component to interpolate the errors for
 * @param {FieldError[]} errors - The errors to interpolate
 * @param {Function} interpolateFn - The interpolation function
 * @returns {[]} - The interpolated errors
 */
const interpolateErrors = (component, errors, interpolateFn) => {
    return errors.map((error) => {
        error.component = component;
        const { errorKeyOrMessage, context } = error;
        const toInterpolate = component.errors && component.errors[errorKeyOrMessage] ? component.errors[errorKeyOrMessage] : errorKeyOrMessage;
        return Object.assign(Object.assign({}, error), { message: unescapeHTML(interpolateFn(toInterpolate, context)), context: Object.assign({}, context) });
    });
};
exports.interpolateErrors = interpolateErrors;
//Simple
/**
 *
 * @param type
 * @param title
 * @param msg
 */
function showPopup(type, title, msg) {
    return __awaiter(this, void 0, void 0, function* () {
        switch (type) {
            case 'warning':
                return yield (0, sweetalert_1.default)({
                    title: (0, exports.getLangText)(title),
                    text: (0, exports.getLangText)(msg),
                    icon: type,
                    buttons: true,
                    dangerMode: true,
                }).then((confirm) => {
                    return confirm;
                });
            case 'success':
            case 'error':
            case 'info':
                (0, sweetalert_1.default)((0, exports.getLangText)(title), (0, exports.getLangText)(msg), type);
                break;
        }
    });
}
exports.showPopup = showPopup;
// hungnq
/**
 *
 * @param type
 */
function getIcon(type) {
    switch (type) {
        case "success":
            return `
          <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="96px" height="96px"><path fill="#4caf50" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"/><path fill="#ccff90" d="M34.602,14.602L21,28.199l-5.602-5.598l-2.797,2.797L21,33.801l16.398-16.402L34.602,14.602z"/></svg>
        `;
        case "error":
            return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="96px" height="96px"><linearGradient id="wRKXFJsqHCxLE9yyOYHkza" x1="9.858" x2="38.142" y1="9.858" y2="38.142" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f44f5a"/><stop offset=".443" stop-color="#ee3d4a"/><stop offset="1" stop-color="#e52030"/></linearGradient><path fill="url(#wRKXFJsqHCxLE9yyOYHkza)" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"/><path d="M33.192,28.95L28.243,24l4.95-4.95c0.781-0.781,0.781-2.047,0-2.828l-1.414-1.414 c-0.781-0.781-2.047-0.781-2.828,0L24,19.757l-4.95-4.95c-0.781-0.781-2.047-0.781-2.828,0l-1.414,1.414 c-0.781,0.781-0.781,2.047,0,2.828l4.95,4.95l-4.95,4.95c-0.781,0.781-0.781,2.047,0,2.828l1.414,1.414 c0.781,0.781,2.047,0.781,2.828,0l4.95-4.95l4.95,4.95c0.781,0.781,2.047,0.781,2.828,0l1.414-1.414 C33.973,30.997,33.973,29.731,33.192,28.95z" opacity=".05"/><path d="M32.839,29.303L27.536,24l5.303-5.303c0.586-0.586,0.586-1.536,0-2.121l-1.414-1.414 c-0.586-0.586-1.536-0.586-2.121,0L24,20.464l-5.303-5.303c-0.586-0.586-1.536-0.586-2.121,0l-1.414,1.414 c-0.586,0.586-0.586,1.536,0,2.121L20.464,24l-5.303,5.303c-0.586,0.586-0.586,1.536,0,2.121l1.414,1.414 c0.586,0.586,1.536,0.586,2.121,0L24,27.536l5.303,5.303c0.586,0.586,1.536,0.586,2.121,0l1.414-1.414 C33.425,30.839,33.425,29.889,32.839,29.303z" opacity=".07"/><path fill="#fff" d="M31.071,15.515l1.414,1.414c0.391,0.391,0.391,1.024,0,1.414L18.343,32.485 c-0.391,0.391-1.024,0.391-1.414,0l-1.414-1.414c-0.391-0.391-0.391-1.024,0-1.414l14.142-14.142 C30.047,15.124,30.681,15.124,31.071,15.515z"/><path fill="#fff" d="M32.485,31.071l-1.414,1.414c-0.391,0.391-1.024,0.391-1.414,0L15.515,18.343 c-0.391-0.391-0.391-1.024,0-1.414l1.414-1.414c0.391-0.391,1.024-0.391,1.414,0l14.142,14.142 C32.876,30.047,32.876,30.681,32.485,31.071z"/></svg>
      `;
        case "warning":
            return `
      <svg xmlns="http://www.w3.org/2000/svg" fill="#ffca28" width="96px" height="96px" viewBox="-1.7 0 20.4 20.4" class="cf-icon-svg"><path d="M16.406 10.283a7.917 7.917 0 1 1-7.917-7.917 7.916 7.916 0 0 1 7.917 7.917zM9.48 14.367a1.003 1.003 0 1 0-1.004 1.003 1.003 1.003 0 0 0 1.004-1.003zM7.697 11.53a.792.792 0 0 0 1.583 0V5.262a.792.792 0 0 0-1.583 0z"/></svg>
      `;
        case "info":
            return `
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 48 48" width="96px" height="96px"><g id="surface1_89_"><path style="fill:#2196F3;" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"/><path style="fill:#FFFFFF;" d="M22,22h4v11h-4V22z"/><path style="fill:#FFFFFF;" d="M26.5,16.5c0,1.379-1.121,2.5-2.5,2.5s-2.5-1.121-2.5-2.5S22.621,14,24,14S26.5,15.121,26.5,16.5z"/></g></svg>
      `;
        default:
            break;
    }
}
/**
 *
 * @param type
 * @param title
 * @param msg
 * @param fullScreen
 * @param buttonSuccessText
 * @param buttonCancelText
 * @param showCancel
 */
function renderPopUpCustom(type, title, msg, fullScreen, buttonSuccessText, buttonCancelText, showCancel) {
    return `
  <div class="modal fade" id="custom-popup-modal"  tabindex="-1">
    <div class="modal-dialog modal-dialog-centered ${fullScreen ? 'modal-fullscreen-sm-down' : ''}">
      <div class="modal-content">
        <div class="modal-body flex sm:ari-block ari-items-center justify-center">

              <div>
                  <div class="ari-p-2 ari-w-fit ari-max-w-[185px] ari-m-auto ari-bg-[#dfdfdf] ari-rounded-xl mb-3">
                      <div class="ari-mb-3 w-fit ari-mx-auto ari-mb-5 ari-flex ari-justify-center">
                          ${getIcon(type)}
                      </div>
                      <div class="ari-font-bold ari-text-center">${(0, exports.getLangText)(title)}</div>
                  </div>
                  <div class="ari-text-center ari-text-[#114c9f]">${(0, exports.getLangText)(msg)}</div>
              </div>

              <div class="ari-w-full ari-mt-4 ari-fixed ari-mt-0 ari-sm:mt-4 ari-w-full sm:ari-static ari-left-0 ari-bottom-0 ari-right-0">
                  <button 
                    class="btn btn-success ari-w-full ari-bg-[#114c9f] ari-text-white ari-font-bold btn-md btn-block" 
                    id="custom-popup-btn-ok"
                  >${(0, exports.getLangText)(buttonSuccessText)}</button>

                  ${showCancel ? `
                    <button 
                      class="btn btn-secondary ari-w-full ari-bg-[#999] ari-text-white ari-font-bold btn-md btn-block ari-mt-2" 
                      id="custom-popup-btn-cancel"
                    >${(0, exports.getLangText)(buttonCancelText)}</button>
                  ` : ''}
              </div>

        </div>
      </div>
    </div>
  </div>
  `;
}
/**
 *
 * @param type
 * @param title
 * @param msg
 * @param fullScreen
 * @param buttonSuccessText
 * @param buttonCancelText
 * @param showCancel
 */
function customShowPopUp(type, title, msg, fullScreen = false, buttonSuccessText, buttonCancelText, showCancel) {
    return new Promise((resolve) => {
        const html = document.createElement('div');
        html.classList.add('custom-popup-wraper');
        html.innerHTML = renderPopUpCustom(type, title, msg, fullScreen, buttonSuccessText, buttonCancelText, showCancel);
        document.body.appendChild(html);
        jQuery(`#custom-popup-modal`).modal('show');
        // Nút OK
        html.querySelector('#custom-popup-btn-ok').addEventListener('click', (e) => {
            e.target.blur();
            jQuery('#custom-popup-modal').modal('hide');
            setTimeout(() => html.remove(), 300);
            resolve(true); // ✔ trả về true
        });
        // Nếu là warning mới có nút Cancel
        const btnCancel = html.querySelector('#custom-popup-btn-cancel');
        if (btnCancel) {
            btnCancel.addEventListener('click', (e) => {
                e.target.blur();
                jQuery('#custom-popup-modal').modal('hide');
                setTimeout(() => html.remove(), 300);
                resolve(false); // ✔ trả về false
            });
        }
    });
}
exports.customShowPopUp = customShowPopUp;
// end HungNQ 
/**
 *
 * @param msg
 * @param opt
 */
function toast(msg, opt = {}) {
    toastr_1.default.options = {
        'closeButton': true,
        'debug': false,
        'newestOnTop': true,
        'progressBar': true,
        'positionClass': 'toast-top-right',
        'preventDuplicates': false,
        'onclick': null,
        'showDuration': '300',
        'hideDuration': '1000',
        'timeOut': '5000',
        'extendedTimeOut': '1000',
        'showEasing': 'swing',
        'hideEasing': 'linear',
        'showMethod': 'fadeIn',
        'hideMethod': 'fadeOut'
    };
    toastr_1.default.info((0, exports.getLangText)(msg), opt);
}
exports.toast = toast;
/**
 *
 * @param title
 * @param msg
 * @param opt
 */
function toastsuccess(title, msg, opt = {}) {
    toastr_1.default.options = {
        'closeButton': true,
        'debug': false,
        'newestOnTop': true,
        'progressBar': true,
        'positionClass': 'toast-top-right',
        'preventDuplicates': false,
        'onclick': null,
        'showDuration': '300',
        'hideDuration': '1000',
        'timeOut': '5000',
        'extendedTimeOut': '1000',
        'showEasing': 'swing',
        'hideEasing': 'linear',
        'showMethod': 'fadeIn',
        'hideMethod': 'fadeOut'
    };
    toastr_1.default.success((0, exports.getLangText)(msg), (0, exports.getLangText)(title), opt);
}
exports.toastsuccess = toastsuccess;
/**
 *
 * @param title
 * @param msg
 * @param opt
 */
function toasterror(title, msg, opt = {}) {
    toastr_1.default.options = {
        'closeButton': true,
        'debug': false,
        'newestOnTop': true,
        'progressBar': true,
        'positionClass': 'toast-top-right',
        'preventDuplicates': false,
        'onclick': null,
        'showDuration': '300',
        'hideDuration': '1000',
        'timeOut': '5000',
        'extendedTimeOut': '1000',
        'showEasing': 'swing',
        'hideEasing': 'linear',
        'showMethod': 'fadeIn',
        'hideMethod': 'fadeOut'
    };
    toastr_1.default.error((0, exports.getLangText)(msg), (0, exports.getLangText)(title), opt);
}
exports.toasterror = toasterror;
/**
 *
 * @param title
 * @param msg
 * @param opt
 */
function toastwarning(title, msg, opt = {}) {
    toastr_1.default.options = {
        'closeButton': true,
        'debug': false,
        'newestOnTop': true,
        'progressBar': true,
        'positionClass': 'toast-top-right',
        'preventDuplicates': false,
        'onclick': null,
        'showDuration': '300',
        'hideDuration': '1000',
        'timeOut': '5000',
        'extendedTimeOut': '1000',
        'showEasing': 'swing',
        'hideEasing': 'linear',
        'showMethod': 'fadeIn',
        'hideMethod': 'fadeOut'
    };
    toastr_1.default.warning((0, exports.getLangText)(msg), (0, exports.getLangText)(title), opt);
}
exports.toastwarning = toastwarning;
/**
 *
 * @param string
 * @param str
 */
function encryptIndexDB(str) {
    return AriForm_1.AriForm.encryptVariable === true || AriForm_1.AriForm.encryptVariable === 'true' ? (0, encrypt_1.encryptAES)(str) : str;
}
exports.encryptIndexDB = encryptIndexDB;
/**
 *
 * @param string
 * @param str
 */
function decryptIndexDB(str) {
    return AriForm_1.AriForm.encryptVariable === true || AriForm_1.AriForm.encryptVariable === 'true' ? (0, encrypt_1.decryptAES)(str) : str;
}
exports.decryptIndexDB = decryptIndexDB;
/**
 *
 * @param url
 * @param allowGetFromUrl
 */
function analysisUrl(url, allowGetFromUrl) {
    if (!url || allowGetFromUrl) {
        url = window.location.href.slice(`${window.location.protocol}//${window.location.host}`.length);
    }
    url = url.charAt(0) === '/' ? url.substring(1, url.length) : url;
    let doubleDecrupt = false;
    if (url.startsWith('ari/')) {
        url = url.substring(4, url.length);
        doubleDecrupt = true;
    }
    var additionLink = AriForm_1.AriForm.additionLink && AriForm_1.AriForm.additionLink.charAt(0) === '/' ? AriForm_1.AriForm.additionLink.slice(1) : AriForm_1.AriForm.additionLink;
    var index = additionLink.length === 0 ? 0 : additionLink.length + 1;
    url = url.slice(index);
    var urlString = "";
    if (AriForm_1.AriForm.encryptUrl === "true" || AriForm_1.AriForm.encryptUrl === true) {
        url = url.replaceAll('_', '/').replaceAll("-", "+");
        urlString = (0, encrypt_1.decryptAES)(url, true);
        if (doubleDecrupt) {
            urlString = urlString.charAt(0) === '/' ? urlString.substring(1, urlString.length) : urlString;
            urlString = (0, encrypt_1.decryptAES)(urlString, true);
        }
    }
    else
        urlString = url;
    urlString = urlString.split('?');
    return urlString;
}
exports.analysisUrl = analysisUrl;
/**
 *
 * @param param
 * @param url
 * @param allowGetFromUrl
 */
function getParamUrl(param, url, allowGetFromUrl) {
    var urlString = analysisUrl(url, allowGetFromUrl);
    if (urlString.length > 1) {
        //var urlQuery = urlString.includes('?') ? urlString.split('?')[1] : urlString;
        var urlSearchParams = new URLSearchParams(urlString[1]);
        var params = Object.fromEntries(urlSearchParams.entries());
        return params[param];
    }
    return null;
}
exports.getParamUrl = getParamUrl;
/**
 *
 * @param url
 * @param allowGetFromUrl
 */
function getContentUrl(url, allowGetFromUrl) {
    return analysisUrl(url, allowGetFromUrl)[0];
}
exports.getContentUrl = getContentUrl;
/**
 *
 * @param url
 * @param isLink
 */
function formatUrl(url, isLink = false) {
    if (url) {
        url = url.charAt(0) === '/' ? url.substring(1, url.length) : url;
        if ((AriForm_1.AriForm.encryptUrl === "true" || AriForm_1.AriForm.encryptUrl === true) && url !== '' && url !== '#') {
            url = (0, encrypt_1.encryptAES)(url, true).replaceAll('/', '_');
        }
        if (AriForm_1.AriForm.additionLink !== '') {
            var addtionLink = AriForm_1.AriForm.additionLink.includes('#') && isLink ? AriForm_1.AriForm.additionLink.substring(1, AriForm_1.AriForm.additionLink.length) : AriForm_1.AriForm.additionLink;
            url = `${addtionLink === '' || addtionLink.charAt(0) === '/' ? '' : '/'}${addtionLink}/${url}`;
        }
        else {
            url = `/${url}`;
        }
    }
    return url || '';
}
exports.formatUrl = formatUrl;
/**
 *
 */
function clearLoginInforClient() {
    localStorage.clear();
}
exports.clearLoginInforClient = clearLoginInforClient;
/**
 *
 * @param key
 */
function getWindowConfig(key) {
    return window[key];
}
exports.getWindowConfig = getWindowConfig;
/**
 *
 * @param code
 * @param key
 * @param _code
 */
function getValueByCode(code, key, _code) {
    var arr = _code.filter(m => m.code === code);
    var result = arr.find(m => m.key === key);
    if (result)
        return result.value;
    result = arr.find(m => m.key === 'DEFAULT');
    if (result)
        return result.value;
    return null;
}
exports.getValueByCode = getValueByCode;
/**
 *
 * @param input
 */
function encryptPassword(input) {
    return (0, sha256_1.default)(input);
}
exports.encryptPassword = encryptPassword;
const getVariable = (key) => {
    if (AriForm_1.AriForm.encryptVariable === false || AriForm_1.AriForm.encryptVariable === 'false') {
        return localStorage.getItem(key);
    }
    var keyEncrypt = (0, encrypt_1.encryptAES)(key);
    if (localStorage.getItem(keyEncrypt)) {
        return (0, encrypt_1.decryptAES)(localStorage.getItem(keyEncrypt));
    }
};
exports.getVariable = getVariable;
const getVariableTemp = (key) => {
    if (AriForm_1.AriForm.encryptVariable === false || AriForm_1.AriForm.encryptVariable === 'false') {
        return sessionStorage.getItem(key);
    }
    var keyEncrypt = (0, encrypt_1.encryptAES)(key);
    if (sessionStorage.getItem(keyEncrypt)) {
        return (0, encrypt_1.decryptAES)(sessionStorage.getItem(keyEncrypt));
    }
};
exports.getVariableTemp = getVariableTemp;
const setVariable = (key, value) => {
    var keyEncrypt = AriForm_1.AriForm.encryptVariable === true || AriForm_1.AriForm.encryptVariable === 'true' ? (0, encrypt_1.encryptAES)(key) : key;
    if (value) {
        var valEncrypt = AriForm_1.AriForm.encryptVariable === true || AriForm_1.AriForm.encryptVariable === 'true' ? (0, encrypt_1.encryptAES)(value) : value;
        localStorage.setItem(keyEncrypt, valEncrypt);
    }
    else {
        localStorage.removeItem(keyEncrypt);
    }
};
exports.setVariable = setVariable;
const setVariableTemp = (key, value) => {
    var keyEncrypt = AriForm_1.AriForm.encryptVariable === true || AriForm_1.AriForm.encryptVariable === 'true' ? (0, encrypt_1.encryptAES)(key) : key;
    if (value) {
        var valEncrypt = AriForm_1.AriForm.encryptVariable === true || AriForm_1.AriForm.encryptVariable === 'true' ? (0, encrypt_1.encryptAES)(value) : value;
        sessionStorage.setItem(keyEncrypt, valEncrypt);
    }
    else {
        sessionStorage.removeItem(keyEncrypt);
    }
};
exports.setVariableTemp = setVariableTemp;
/**
 *
 * @param val
 * @param addition
 */
function numberToEnglishText(val, addition) {
    var NUMBER2TEXT = {
        ones: ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'],
        tens: ['', '', 'twenty', 'thirty', 'fourty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'],
        sep: ['', ' thousand ', ' million ', ' billion ', ' trillion ', ' quadrillion ', ' quintillion ', ' sextillion ']
    };
    var ones = NUMBER2TEXT.ones, tens = NUMBER2TEXT.tens, sep = NUMBER2TEXT.sep, arr = [], str = '', i = 0;
    val = parseInt(val, 10);
    while (val) {
        arr.push(val % 1000);
        val = parseInt(val / 1000, 10);
    }
    while (arr.length) {
        str = (function (a) {
            var x = Math.floor(a / 100), y = Math.floor(a / 10) % 10, z = a % 10;
            return (x > 0 ? `${ones[x]} hundred ` : '') + (y >= 2 ? `${tens[y]} ${ones[z]}` : ones[10 * y + z]);
        })(arr.shift()) + sep[i++] + str;
    }
    return `${str[0].toUpperCase()}${str.slice(1)} ${addition}`;
}
exports.numberToEnglishText = numberToEnglishText;
const getLangText = (key) => {
    var _a;
    //return i18next.t(key) ? i18next.t(key) : key;  
    const lang = AriForm_1.AriForm.language || 'en';
    const i18n = ((_a = AriForm_1.AriForm.i18n) === null || _a === void 0 ? void 0 : _a[lang]) || {};
    // Hỗ trợ key dạng "a.b.c"
    // const segments = key.split('.');
    // let value = i18n;
    // for (let seg of segments) {
    //   if (typeof value !== 'object' || !(seg in value)) {
    //     return key; 
    //   }
    //   value = value[seg];
    // }
    // return typeof value === 'string' ? value : key;
    return (key in i18n) ? i18n[key] : key;
};
exports.getLangText = getLangText;
/**
 *
 * @param val
 * @param addition
 */
function numberToText(val, addition) {
    var lang = (0, exports.getVariable)('lang'); //localStorage.getItem('lang');
    if (lang === 'mk-MK') {
        return myanmar_num_to_word_1.myanmarNumToWord.convertToBurmeseWords(val) + addition;
    }
    else {
        // eslint-disable-next-line no-undef
        return numberToEnlishText(val, addition);
    }
}
exports.numberToText = numberToText;
/**
 *
 * @param list
 * @param propertyKey
 * @param propertyVal
 * @param val
 * @param replaceText
 */
function mappingData(list, propertyKey, propertyVal, val, replaceText = '') {
    if (list && val) {
        var rs = list.find(m => m[propertyKey] === val);
        if (!rs) {
            return replaceText;
        }
        return rs[propertyVal];
    }
    else
        return replaceText;
}
exports.mappingData = mappingData;
/**
 *
 * @param cacheName
 * @param url
 * @param response
 */
function saveCache(cacheName, url, response) {
    return __awaiter(this, void 0, void 0, function* () {
        if (AriForm_1.AriForm.cacheType !== 'NOCACHE') {
            if ('caches' in window) {
                const newCache = yield caches.open(cacheName);
                newCache.put(url, new Response(response));
            }
        }
    });
}
exports.saveCache = saveCache;
/**
 *
 * @param cacheName
 * @param url
 */
function getCache(cacheName, url) {
    if (AriForm_1.AriForm.cacheType !== 'NOCACHE') {
        return caches.has(cacheName).then((hasCache) => __awaiter(this, void 0, void 0, function* () {
            if (hasCache) {
                const cacheStorage = yield caches.open(cacheName);
                const cachedResponse = yield cacheStorage.match(url);
                var data = yield cachedResponse.json();
                return data;
            }
        })).catch(() => {
        });
    }
}
exports.getCache = getCache;
/**
 *
 */
function deleteAllCache() {
    if (AriForm_1.AriForm.cacheType !== 'FULLCACHE') {
        caches.keys().then((keyList) => Promise.all(keyList.map((key) => {
            return caches.delete(key);
        })));
    }
}
exports.deleteAllCache = deleteAllCache;
/**
 *
 * @param key
 */
function getParamConfig(key) {
    return execExternalFunction('getParamConfig', key);
}
exports.getParamConfig = getParamConfig;
// hungnq 
/**
 *
 * @param functionName
 * @param param
 */
function execExternalFunction(functionName, param) {
    var func = AriForm_1.AriForm.function.find(m => m.functionName === functionName);
    if (func) {
        return func.Function(param);
    }
    else if (AriForm_1.AriForm.execExternalFunction) {
        param.name = functionName;
        return AriForm_1.AriForm.execExternalFunction(param);
    }
}
exports.execExternalFunction = execExternalFunction;
/**
 *
 * @param functionName
 * @param param
 */
function execAsyncExternalFunction(functionName, param) {
    return __awaiter(this, void 0, void 0, function* () {
        var func = AriForm_1.AriForm.function.find(m => m.functionName === functionName);
        if (func) {
            return yield func.Function(param);
        }
        else if (AriForm_1.AriForm.execExternalFunction) {
            param.name = functionName;
            return yield AriForm_1.AriForm.execExternalFunction(param);
        }
    });
}
exports.execAsyncExternalFunction = execAsyncExternalFunction;
// hungnq 
/**
 *
 * @param methodName
 * @param param
 * @param params
 */
function excecAPIExternalFunction(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield AriForm_1.AriForm.callApiFromExternalFunc(params);
        return result;
    });
}
exports.excecAPIExternalFunction = excecAPIExternalFunction;
// hungnq 
/**
 *
 * @param params
 * @param handleSuccess
 * @param handleError
 */
function excecAsyncAPIExternalFunction(params, handleSuccess, handleError) {
    return excecAPIExternalFunction(params).then((result) => {
        var _a, _b;
        const responseData = safeParse((_b = (_a = result === null || result === void 0 ? void 0 : result.content) === null || _a === void 0 ? void 0 : _a.result) !== null && _b !== void 0 ? _b : null);
        if ((result === null || result === void 0 ? void 0 : result.statusCode) === 200) {
            if (handleSuccess)
                handleSuccess(responseData);
        }
        else {
            if (handleError)
                handleError(responseData);
        }
    }).catch((error) => {
        if (handleError)
            handleError(error);
    });
}
exports.excecAsyncAPIExternalFunction = excecAsyncAPIExternalFunction;
// hungnq - 2023/10/16
/**
 * Safely parses a string as JSON, returning the original string if parsing fails.
 * @param {string} str - The string to parse.
 * @returns {any} - The parsed JSON object, or the original string if parsing fails.
 */
function safeParse(str) {
    if (typeof str !== 'string')
        return str;
    try {
        const parsed = JSON.parse(str);
        return parsed;
    }
    catch (e) {
        return str;
    }
}
exports.safeParse = safeParse;
// end hungnq - 2023/10/16
/**
 *
 * @param methodname
 * @param param
 */
function invokeMobileFunction(methodname, param) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            // eslint-disable-next-line no-undef
            return yield DotNet.invokeMethodAsync('DigitalViewHelper', 'InvokeMobileMethod', { methodName: methodname, methodParam: param });
        }
        catch (error) {
            let result;
            if (error.message === 'No .NET call dispatcher has been set.') {
                window.Blazor.start().then(
                // eslint-disable-next-line no-undef
                result = yield DotNet.invokeMethodAsync('DigitalViewHelper', 'InvokeMobileMethod', { methodName: methodname, methodParam: param }));
                return result;
            }
        }
    });
}
exports.invokeMobileFunction = invokeMobileFunction;
//Simple add format string (code from ManhDD)
/**
 *
 * @param str
 * @param obj
 */
function formatParamString(str, obj) {
    const params = obj;
    if (!str)
        return '';
    /* eslint-disable-next-line */
    return str.replace(/\{[^\{\}]+\}/g, matchedStr => {
        const variableIndex = matchedStr.replace('{', '').replace('}', '');
        return params[variableIndex];
    });
}
exports.formatParamString = formatParamString;
/**
 *
 * @param data
 * @param contentType
 */
function cer(data, contentType) {
    let clientPublicKey = (0, exports.getVariableTemp)('cpubk');
    if (!clientPublicKey) {
        const keys = (0, encrypt_1.genarateRSA)();
        (0, exports.setVariableTemp)('cprik', keys[0]);
        (0, exports.setVariableTemp)('cpubk', keys[1]);
        clientPublicKey = keys[1];
    }
    const rsaClientLen = '00000000'.concat(clientPublicKey.length.toString(16)).slice(-8);
    const contentTypeLen = '00'.concat(contentType.length.toString(16)).slice(-2);
    const dataSum = rsaClientLen.concat(contentTypeLen, clientPublicKey, contentType, data);
    const passAes = guid();
    const dataEn = (0, encrypt_1.encryptAESCBC)(dataSum, passAes);
    const passRsa = (0, encrypt_1.encryptRSA)(passAes);
    const passRsaLen = '00000000'.concat(passRsa.length.toString(16)).slice(-8);
    const strSum = passRsaLen.concat(passRsa, dataEn);
    return strSum;
}
exports.cer = cer;
/**
 *
 * @param data
 */
function declareGlobalsFromObject(data) {
    if (data && typeof data === 'object') {
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                window[key] = data[key];
            }
        }
    }
}
/**
 *
 * @param data
 */
function cdr(data) {
    const clientPrivateKey = (0, exports.getVariableTemp)('cprik');
    const aesKeyLen = parseInt(data.substring(0, 8), 16);
    const contentTypeLen = parseInt(data.substring(8, 10), 16);
    const aesKeyEn = data.substring(10, aesKeyLen + 10);
    const aesKey = (0, encrypt_1.decryptRSA)(aesKeyEn, clientPrivateKey);
    const dataSumEn = data.substring(10 + aesKeyLen);
    const dataSum = (0, encrypt_1.decryptAESCBC)(dataSumEn, aesKey);
    const contentType = dataSum.substring(0, contentTypeLen);
    const dataDe = dataSum.substring(contentTypeLen);
    return {
        ResponseContent: dataDe,
        ContentType: contentType
    };
}
exports.cdr = cdr;
//Lannth - use noeval
/**
 *
 * @param input
 */
function tokenize(input) {
    // Updated regex to correctly handle single-quoted strings as one token
    const regex = /!!|\d+(\.\d+)?|[+\-*/^(){}=,\.!?;|&<>^%?:!~]|\w+|'[^']*'|\"[^\"]*\"/g; //eslint-disable-line
    return input.match(regex);
}
/**
 *
 * @param tokens
 */
function parse(tokens) {
    let index = 0;
    /**
     *
     */
    function parseExpression() {
        let left = parseLogicalOr();
        while (tokens[index] === '?' || tokens[index] === ':') {
            const operator = tokens[index];
            index++;
            const right = parseLogicalOr();
            left = { type: 'ternary', operator, left, right };
        }
        return left;
    }
    /**
     *
     */
    function parseLogicalOr() {
        let left = parseLogicalAnd();
        while (tokens[index] === '||') {
            const operator = tokens[index];
            index++;
            const right = parseLogicalAnd();
            left = { type: 'binary', operator, left, right };
        }
        return left;
    }
    /**
     *
     */
    function parseLogicalAnd() {
        let left = parseUnary();
        while (tokens[index] === '&&') {
            const operator = tokens[index];
            index++;
            const right = parseUnary();
            left = { type: 'binary', operator, left, right };
        }
        return left;
    }
    /**
     *
     */
    function parseUnary() {
        const token = tokens[index];
        // Handling the !! operator (logical negation)
        if (token === '!!') {
            index++;
            const operand = parseUnary(); // Parse the next expression
            return { type: 'unary', operator: '!!', operand };
        }
        // Handling other unary operators like !, +, -, etc.
        if (token === '!') {
            index++;
            const operand = parseUnary();
            return { type: 'unary', operator: '!', operand };
        }
        return parsePrimary();
    }
    /**
     *
     */
    function parsePrimary() {
        const token = tokens[index];
        // If we encounter '(' we need to parse the expression inside parentheses
        if (token === '(') {
            index++;
            const expr = parseExpression();
            if (tokens[index] === ')') {
                index++; // Skip closing ')'
                return expr;
            }
            throw new Error('Expected closing parenthesis');
        }
        // If the token is a number (literal)
        if (/\d+(\.\d+)?/.test(token)) {
            index++;
            return { type: 'literal', value: parseFloat(token) };
        }
        // If the token is a word (could be an object path or function)
        if (/[a-zA-Z_]\w*/.test(token)) {
            return parseObjectOrFunctionCall();
        }
        throw new Error(`Unexpected token: ${token}`);
    }
    /**
     *
     */
    function parseObjectOrFunctionCall() {
        const token = tokens[index];
        let objectPath = token;
        index++;
        // Parse function calls (if there's a '(' next)
        while (tokens[index] === '.' || tokens[index] === '(') {
            if (tokens[index] === '.') {
                index++;
                objectPath += `.${tokens[index]}`;
                index++;
            }
            else if (tokens[index] === '(') {
                index++;
                const args = parseArguments();
                return { type: 'function', name: objectPath, args };
            }
        }
        return { type: 'object', path: objectPath };
    }
    /**
     *
     */
    function parseArguments() {
        const args = [];
        while (tokens[index] !== ')') {
            args.push(parseExpression());
            if (tokens[index] === ',') {
                index++; // Skip comma
            }
        }
        index++; // Skip closing ')'
        return args;
    }
    return parseExpression();
}
// Interpreter: Thực thi cây cú pháp
/**
 *
 * @param ast
 * @param count
 * @param context
 */
function interpret(ast, count, context = {}) {
    if (ast.type === 'literal') {
        return ast.value;
    }
    count++;
    //console.log( '-----------',count)
    //console.log( '-----------',ast,'--',count)
    if (ast.type === 'binary') {
        //console.log('binary: ',ast,'-----',count)
        const leftValue = interpret(ast.left, count, context);
        const rightValue = interpret(ast.right, count, context);
        switch (ast.operator) {
            case '+': return leftValue + rightValue;
            case '-': return leftValue - rightValue;
            case '*': return leftValue * rightValue;
            case '/': return leftValue / rightValue;
            case '==': return leftValue === rightValue;
            case '!=': return leftValue !== rightValue;
            case '<': return leftValue < rightValue;
            case '>': return leftValue > rightValue;
            case '<=': return leftValue <= rightValue;
            case '>=': return leftValue >= rightValue;
            default: throw new Error(`Unknown operator: ${ast.operator}`);
        }
    }
    if (ast.type === 'unary') {
        const value = interpret(ast.operand, count, context);
        if (ast.operator === '!') {
            return !value;
        }
        else if (ast.operator === '!!') {
            return !!value;
        }
        throw new Error(`Unknown unary operator: ${ast.operator}`);
    }
    if (ast.type === 'ternary') {
        const condition = interpret(ast.left, count, context);
        return condition ? interpret(ast.left, count, context) : interpret(ast.right, count, context);
    }
    if (ast.type === 'object') {
        return resolveObject(ast.path, context);
    }
    if (ast.type === 'function') {
        const func = resolveObject(ast.name, context);
        const args = ast.args.map(arg => interpret(arg, count, context));
        return func(...args);
    }
    throw new Error(`Unknown AST node type: ${ast.type}`);
}
// Hàm hỗ trợ truy vấn đối tượng và gọi phương thức
/**
 *
 * @param path
 * @param context
 */
function resolveObject(path, context) {
    const keys = path.split('.');
    let result = context;
    for (const key of keys) {
        if (result[key] !== undefined) {
            result = result[key];
        }
        else {
            result = key;
        }
    }
    return result;
}
/**
 *
 * @param jsString
 * @param context
 */
function runJSFromString(jsString, context = {}) {
    try {
        const tokens = tokenize(jsString.replace(/!!/g, ''));
        const ast = parse(tokens);
        return interpret(ast, 0, context);
    }
    catch (error) {
        console.error('Error executing the code:', error);
        return null;
    }
}
exports.runJSFromString = runJSFromString;
//End Simple
//Fiona
/**
 *
 * @param title
 * @param msg
 * @param submitButtonText
 * @param className
 * @param element
 */
function comfirmwithInput(title, msg, submitButtonText, className, element = []) {
    return __awaiter(this, void 0, void 0, function* () {
        /**
         *
         */
        function createTextInputs() {
            var _a;
            var inputGroup = document.createElement('div');
            inputGroup.classList.add('swal-input-group');
            for (var i = 0; i < element.length; i++) {
                var input = document.createElement('input');
                input.type = 'text';
                input.classList.add('swal-input', 'form-control', 'mt-3', (_a = element[i]) === null || _a === void 0 ? void 0 : _a.className);
                input.id = `${element[i].id}`;
                input.placeholder = (0, exports.getLangText)(element[i].placeholders) || '';
                input.required = element[i].required;
                inputGroup.appendChild(input);
            }
            return inputGroup;
        }
        var inputs = createTextInputs(element.length);
        return yield (0, sweetalert_1.default)({
            title: (0, exports.getLangText)(title),
            content: inputs,
            text: (0, exports.getLangText)(msg),
            icon: 'warning',
            dangerMode: true,
            className: className,
            buttons: {
                cancel: (0, exports.getLangText)('Cancel'),
                confirm: {
                    text: (0, exports.getLangText)(submitButtonText),
                    value: true,
                    closeModal: false
                }
            }
        }).then((confirm) => {
            if (confirm) {
                var inputElements = inputs.querySelectorAll('.swal-input');
                var values = {};
                inputElements.forEach(function (input) {
                    values[input.id] = input.value;
                });
                sweetalert_1.default.close();
                return values;
            }
        });
    });
}
exports.comfirmwithInput = comfirmwithInput;
/**
 * Format number with commas and optional decimal places
 * @param {number|string} number - Number to format
 * @param {number} [decimals] - Number of decimal places (0 to disable decimals)
 * @returns {string} Formatted number string
 */
function numberWithCommas(number, decimals = 2) {
    const language = (0, exports.getVariable)('BlazorCulture');
    // Convert valid string numbers to number type
    if (typeof number === 'string' && !isNaN(Number(number))) {
        number = Number(number);
    }
    // Return original if not a valid number
    if (typeof number !== 'number' || isNaN(number)) {
        return number;
    }
    // Handle zero decimals case
    if (decimals === 0) {
        return Math.round(number).toLocaleString();
    }
    // Format with decimals
    return number.toLocaleString(language || 'en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });
}
exports.numberWithCommas = numberWithCommas;
//end Fiona
/**
 *
 * @param  number
 * @param decimals
 * @param valueType
 * @param value
 * @param type
 * @param options
 * @param source
 */
// export function numberWithCommas(number, decimals) {
//   var decpoint = '.'; // Or Number(0.1).toLocaleString().substring(1, 2)
//   var thousand = ','; // Or Number(10000).toLocaleString().substring(2, 3)
//   if (!decimals) decimals = 2;
//   var n = Math.abs(number).toFixed(decimals).split('.');
//   n[0] = n[0].split('').reverse().map((c, i, a) =>
//     i > 0 && i < a.length && i % 3 === 0 ? c + thousand : c
//   ).reverse().join('');
//   return (Math.sign(number) < 0 ? '-' : '') + n.join(decpoint);
// }
function formatValueOfParam(valueType, value, source) {
    var _a, _b, _c;
    switch (valueType) {
        case 'DATA':
            return " " + ((_c = (_b = (_a = source === null || source === void 0 ? void 0 : source.find) === null || _a === void 0 ? void 0 : _a.call(source, x => x.datasetField == value)) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : '');
        case 'VALUE':
            return value;
        case "SOURCE": return source[value];
        default:
            return value;
    }
}
/**
 *
 * @param options
 * @param key
 * @param source
 * @param defaultValue
 */
function formatParam(options, key, source, defaultValue) {
    if (options[key]) {
        return formatValueOfParam(options[key].valueType, options[key].value, source);
    }
    else {
        return defaultValue;
    }
}
// hungnq
/**
 *
 * @param value
 * @param type
 * @param options
 * @param source
 */
function dynamicFormat(value, type, options = {}, source = {}) {
    // === 2. FORMATTING ===
    options = typeof options === 'string' ? JSON.parse(options) : options;
    type = type.toLowerCase();
    try {
        switch (type) {
            case 'number':
            case 'amount': {
                if (value) {
                    const numericValue = typeof value === 'string' && value ? Number(value) : value;
                    const decimals = formatParam(options, 'format', source, 2);
                    return numberWithCommas(numericValue, decimals) + formatParam(options, 'currency', source, '');
                }
                else {
                    return 0;
                }
            }
            case 'datetime': {
                const inputFormat = formatParam(options, 'inputFormat', source, null);
                const outputFormat = formatParam(options, 'outputFormat', source, 'DD/MM/YYYY, HH:mm:ss');
                if (!value)
                    return "-";
                let m = inputFormat
                    ? (0, moment_timezone_1.default)(value, inputFormat, true)
                    : (0, moment_timezone_1.default)(value);
                if (!m.isValid()) {
                    m = (0, moment_timezone_1.default)(value);
                }
                if (!m.isValid())
                    return "-";
                return m.format(outputFormat);
            }
            default: {
                return value;
            }
        }
    }
    catch (error) {
        throw new Error(`Formatting failed: ${error.message}`);
    }
}
exports.dynamicFormat = dynamicFormat;
/**
 *
 * @param value
 * @param key
 */
function renderCarouselIndicators(value, key) {
    let indicators = '';
    value.forEach((img, index) => {
        indicators += `<button type="button" data-bs-target="#${key}-myCarousel" data-bs-slide-to="${index}" class="${index === 0 ? 'active' : ''}" aria-current="${index === 0 ? 'true' : 'false'}" aria-label="Slide ${index + 1}"></button>`;
    });
    return indicators;
}
/**
 *
 * @param value
 * @param key
 */
function renderCarouselItems(value, key) {
    let items = '';
    value.forEach((img, index) => {
        items += `<div class="carousel-item ${index === 0 ? 'active' : ''}">
                <img src="${img.url}"  class="d-block w-full ari-min-h-[300px]" style="object-fit: contain;" alt="Image ${index + 1}">
              </div>`;
    });
    return items;
}
/**
 *
 * @param value
 * @param key
 */
function ViewImage(value, key) {
    return `<div type="button" class="" data-bs-toggle="modal" data-bs-target="#${key}-modal-image">
  ${(0, exports.getLangText)('View Image')}
</div>

<div class="modal fade" id="${key}-modal-image" tabindex="-1" aria-labelledby="${key}-modal-imageLabel">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content ">
      <div class="modal-body">
        <div id="${key}-myCarousel" data-bs-interval="false" class="carousel slide">
            <div class="carousel-indicators">
              ${value && (value === null || value === void 0 ? void 0 : value.length) > 1 ? renderCarouselIndicators(value, key) : ''}
            </div>

            <div class="carousel-inner">
              ${renderCarouselItems(value, key)}
            </div>

            <button class="carousel-control-prev" type="button" data-bs-target="#${key}-myCarousel" data-bs-slide="prev">
              <span class="carousel-control-prev-icon"></span>
            </button>

            <button class="carousel-control-next" type="button" data-bs-target="#${key}-myCarousel" data-bs-slide="next">
              <span class="carousel-control-next-icon"></span>
            </button>
          </div>

      </div>
    </div>
  </div>
</div>`;
}
/**
 *
 * @param value
 */
function ViewFile(value) {
    return `<div>${value.fileName}</div>`;
}
/**
 *
 * @param value
 */
function renderTHTable(value) {
    return value
        .map(v => `<th>${v}</th>`)
        .join('');
}
/**
 *
 * @param dataFormat
 * @param item
 * @param source
 */
function renderTDTable(dataFormat, item, source) {
    return dataFormat
        .map(j => {
        const raw = item[j.rowData];
        if (raw === undefined || raw === null)
            return '';
        return `<td>${dynamicFormat(raw, j.formatType, j.formatParam, source)}</td>`;
    })
        .join('');
}
/**
 *
 * @param dataItem
 * @param dataFormat
 * @param source
 */
function RenderItemTable(dataItem, dataFormat, source) {
    return dataItem
        .map(v => {
        return `<tr>${renderTDTable(dataFormat, v, source)}</tr>`;
    })
        .join('');
}
/**
 *
 * @param value
 * @param type
 * @param format
 * @param source
 * @param key
 * @param comp
 * @param form
 * @param AriFormUtils
 */
function dynamicFormatTemplate(value, type, format, source = {}, key, comp, form, AriFormUtils) {
    switch (type) {
        case 'file': {
            const imageTypes = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
            const fileTypes = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.txt', '.zip', '.rar'];
            if (value.length > 0) {
                const isImage = imageTypes.includes(value[0].fileType);
                const isFile = fileTypes.includes(value[0].fileType);
                if (isImage) {
                    return ViewImage(value, key);
                }
                else {
                    return ViewFile(value[0]);
                }
            }
            else {
                return '-';
            }
        }
        case 'textinfo':
            var templateStr = lodash_1.default.get(comp.component, 'templatesTextinfo');
            var renderByTemplate = lodash_1.default.template(templateStr);
            var html = renderByTemplate({
                value,
                form,
                utils: AriFormUtils,
                data: form.getValue().data,
            });
            return `<div class="ari-w-full">${html}</div>`;
        case 'rowDisplay': {
            const rows = value.map(v => {
                const oneRow = format.items
                    .map(f => {
                    const raw = v[f.rowData];
                    if (raw === undefined || raw === null)
                        return undefined;
                    return dynamicFormat(raw, f.formatType, f.formatParam, source);
                })
                    .filter(x => x !== undefined && x !== null && x !== "");
                return `<li>${oneRow.join(format.character)}</li>`;
            });
            return `<ul style="list-style-type: disc; margin-left:20px">${rows.filter(r => r).join("\n")}</ul>`;
        }
        case 'text': {
            return value;
        }
        case 'table': {
            return `<table class="table">
      <thead class="editgrid-table-head">
          <tr>${renderTHTable(format.columnName)}</tr>
      </thead>
       <tbody class="editgrid-table-body">
        ${RenderItemTable(value, format.items, source)}
       </tbody> 
      </table>`;
        }
        case 'repeater': {
            const newItem = value.map(v => {
                const found = format.items.find(j => j.rowData in v);
                if (found) {
                    v[found.rowData] = dynamicFormat(v[found.rowData], found.formatType, found.formatParam, source);
                }
                return v;
            });
            const renderByTemplate = lodash_1.default.template(format.template);
            const html = renderByTemplate({
                value: newItem,
                form,
                utils: AriFormUtils,
                data: form.getValue().data,
            });
            return html;
        }
        default:
            break;
    }
}
exports.dynamicFormatTemplate = dynamicFormatTemplate;
// hungnq custom 
/**
 *
 */
function generateUUID() {
    let d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now();
    }
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
    });
}
exports.generateUUID = generateUUID;
/**
 *
 */
function generateRandomString() {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < 92; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
exports.generateRandomString = generateRandomString;
/**
 *
 */
function getDeviceId() {
    return generateUUID() + generateRandomString();
}
exports.getDeviceId = getDeviceId;
/**
 *
 */
function getClientInfo() {
    return __awaiter(this, void 0, void 0, function* () {
        const deviceId = getDeviceId();
        const clientInfo = JSON.stringify({
            "DeviceId": deviceId,
            "DeviceInfo": {
                "Name": navigator.appCodeName,
                "Version": navigator.appVersion,
                "ScreenWidth": window.screen.width,
                "ScreenHeight": window.screen.height,
                "ScreenDensity": window.devicePixelRatio,
            },
            "DeviceType": 'WEB',
            "UserAgent": window.navigator.userAgent
        });
        (0, exports.setVariable)('clientInfo', clientInfo);
        return clientInfo;
    });
}
exports.getClientInfo = getClientInfo;
/**
 *
 * @param components
 * @param targetTypes
 */
function getKeysByType(components, targetTypes) {
    let resultComponents = []; // Thay đổi tên biến từ keys sang resultComponents
    /**
     *
     * @param node
     */
    function traverse(node) {
        // Xử lý nested components
        if (node.components) {
            node.components.forEach(traverse);
        }
        // Xử lý columns
        if (node.columns) {
            node.columns.forEach(col => { var _a; return (_a = col.components) === null || _a === void 0 ? void 0 : _a.forEach(traverse); });
        }
        // Xử lý rows (cho datagrid)
        if (node.rows) {
            node.rows.forEach(row => { var _a; return (_a = row.components) === null || _a === void 0 ? void 0 : _a.forEach(traverse); });
        }
        // Kiểm tra type và thêm component vào kết quả
        if (targetTypes.includes(node.type)) {
            resultComponents.push(node);
        }
    }
    components.forEach(traverse);
    return resultComponents;
}
exports.getKeysByType = getKeysByType;
/**
 *
 * @param params
 */
function encryptRequest(params) {
    return (AriForm_1.AriForm.encryptRequest === true || AriForm_1.AriForm.encryptRequest === 'true') && params ? cer(JSON.stringify(params), 'application/json') : params;
}
exports.encryptRequest = encryptRequest;
/**
 *
 */
function getBaseURL() {
    return AriForm_1.AriForm.serviceId.toLowerCase() === 'tp' ? window.location.origin : AriForm_1.AriForm.baseUrl;
}
exports.getBaseURL = getBaseURL;
/**
 *
 * @param response
 */
function decryptResponse(response) {
    if ((AriForm_1.AriForm.encryptRequest === true || AriForm_1.AriForm.encryptRequest === 'true') && response) {
        const decrypted = cdr(response);
        return JSON.parse(decrypted.ResponseContent);
    }
    return response;
}
exports.decryptResponse = decryptResponse;
// end hungnq custom
// hungnq - 2025/09/04
/**
 *
 * @param endpoint
 * @param method
 * @param params
 * @param header
 * @param handleSuccess
 * @param handleError
 */
function handleCAllAPI(endpoint, method, params, header, handleSuccess, handleError) {
    if (AriForm_1.AriForm.callApiFromExternal === true || AriForm_1.AriForm.callApiFromExternal === 'true') {
        excecAsyncAPIExternalFunction({
            endpointUrl: endpoint,
            method: method,
            body: params,
        }, handleSuccess, (responseData) => {
            if (handleError) {
                handleError(responseData === null || responseData === void 0 ? void 0 : responseData.responseDesc);
            }
        });
    }
    else {
        const ariHeader = (0, exports.getVariable)('clientInfo') ? (0, exports.getVariable)('clientInfo') : getClientInfo();
        const ariLang = (0, exports.getVariable)('BlazorCulture') || 'en-US';
        AriForm_1.AriForm.makeStaticRequest(endpoint, method, encryptRequest(params), {
            headers: Object.assign(Object.assign(Object.assign({}, header), (!(header === null || header === void 0 ? void 0 : header['Content-Type']) && !(header === null || header === void 0 ? void 0 : header['content-type']) && {
                'Content-Type': AriForm_1.AriForm.encryptRequest
                    ? 'text/plain'
                    : 'application/json'
            })), { 'Authorization': (0, exports.getVariable)('token'), "Ari-ClientInfo": ariHeader, "Ari-Lang": ariLang })
        }).then(res => handleSuccess(decryptResponse(res))).catch((error) => {
            var _a;
            if (handleError) {
                const errorData = error;
                handleError(errorData);
            }
            if (AriForm_1.AriForm === null || AriForm_1.AriForm === void 0 ? void 0 : AriForm_1.AriForm.handleError) {
                AriForm_1.AriForm === null || AriForm_1.AriForm === void 0 ? void 0 : AriForm_1.AriForm.handleError({
                    errorCode: ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) || "",
                    oldPath: window.location.pathname
                });
            }
        });
    }
}
exports.handleCAllAPI = handleCAllAPI;
// end hungnq - 2025/09/04
// hungnq - 25/10/31
/**
 *
 * @param el
 */
function loadingAnimation(el) {
    const loadingButton = document.querySelector(el);
    if (loadingButton) {
        loadingButton.disabled = true;
        loadingButton.innerHTML = ` <svg class="mr-3 size-5 animate-spin" viewBox="0 0 24 24"></svg>`;
    }
}
exports.loadingAnimation = loadingAnimation;
/**
 *
 * @param el
 */
function removeLoadingAnimation(el) {
    const loadingButton = document.querySelector(el);
    if (loadingButton) {
        loadingButton.disabled = false;
        loadingButton.querySelector('svg').remove();
    }
}
exports.removeLoadingAnimation = removeLoadingAnimation;
/**
 *
 */
function loadingFullScreen() {
    const fullScreenLoader = document.createElement('div');
    fullScreenLoader.className = 'full-screen-loader ari-fixed ari-top-0 ari-left-0 ari-w-full ari-h-full ari-bg-black/50 ari-flex ari-items-center ari-justify-center ari-z-[10000000000]';
    fullScreenLoader.innerHTML = `
      <div class="loader-content">
        <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      </div>
    `;
    document.body.appendChild(fullScreenLoader);
}
exports.loadingFullScreen = loadingFullScreen;
/**
 *
 */
function removeLoadingFullScreen() {
    const fullScreenLoader = document.querySelector('.full-screen-loader');
    if (fullScreenLoader) {
        document.body.removeChild(fullScreenLoader);
    }
}
exports.removeLoadingFullScreen = removeLoadingFullScreen;
/**
 * Duyệt đệ quy toàn bộ component instance trong form.
 * Bao gồm các con nằm trong columns, panels, containers, datagrid, editgrid, tabs, v.v.
 * @param {object} form - instance của Formio form (đã render)
 * @returns {Array} - danh sách tất cả component (bao gồm cả cha & con)
 */
function getAllFormComponents(form) {
    const result = [];
    /**
     *
     * @param components
     */
    function traverse(components) {
        (components || []).forEach(comp => {
            result.push(comp);
            // Trường hợp 1: có comp.components (container, panel, fieldset, v.v.)
            if (Array.isArray(comp.components)) {
                traverse(comp.components);
            }
            // Trường hợp 2: columns (mảng các object có .components)
            if (Array.isArray(comp.columns)) {
                comp.columns.forEach(col => traverse(col.components));
            }
            // Trường hợp 3: rows (DataGrid, EditGrid)
            if (Array.isArray(comp.rows)) {
                comp.rows.forEach(row => {
                    if (Array.isArray(row)) {
                        row.forEach(cell => traverse(cell.components));
                    }
                });
            }
            // Trường hợp 4: tabs
            if (Array.isArray(comp.tabs)) {
                comp.tabs.forEach(tab => traverse(tab.components));
            }
            // Trường hợp 5: tree (ít gặp nhưng có thể có)
            if (Array.isArray(comp.tree)) {
                traverse(comp.tree);
            }
        });
    }
    traverse(form.components);
    return result;
}
exports.getAllFormComponents = getAllFormComponents;
/**
 *
 */
function scrollToTop() {
    document.querySelector('.mud-main-content').scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
}
exports.scrollToTop = scrollToTop;
/**
 *
 * @param url
 * @param taskId
 * @param title
 * @param body
 * @param backBtn
 * @param previewBtn
 */
function viewTaskDetail(url, title, body, backBtn, previewBtn) {
    customShowPopUp('success', title, body, true, backBtn, previewBtn, true).then((rs) => {
        if (rs) {
            execExternalFunction('redirectUrl', '/');
        }
        else {
            execExternalFunction('redirectUrl', (AriForm_1.AriForm.encryptUrl === "true" || AriForm_1.AriForm.encryptUrl === true) ? `/ari${formatUrl(url)}` : formatUrl(url));
        }
    });
}
exports.viewTaskDetail = viewTaskDetail;
/**
 *
 * @param body
 * @param title
 * @param text
 * @param url
 * @param options
 */
function callAPINextStep(body, options = {}) {
    const { title = 'Success', text = 'Do you want to continue?', confirmText = 'Continue', cancelText = 'Cancel', onCancel = null } = options;
    const handleSuccessGetNextStep = (result) => {
        removeLoadingFullScreen();
        if (!result.isTaskOfCurrentUser)
            return;
        (0, sweetalert_1.default)({
            title: (0, exports.getLangText)(title),
            text: (0, exports.getLangText)(text),
            icon: "success",
            buttons: {
                cancel: {
                    text: (0, exports.getLangText)(cancelText),
                    visible: true,
                    closeModal: true
                },
                confirm: {
                    text: (0, exports.getLangText)(confirmText),
                    closeModal: true
                }
            },
            dangerMode: false,
        }).then((isConfirm) => {
            if (isConfirm) {
                const urlLink = (AriForm_1.AriForm.encryptUrl === "true" || AriForm_1.AriForm.encryptUrl === true)
                    ? `/ari${formatUrl(result.redirectLink)}`
                    : formatUrl(result.redirectLink);
                window.location.replace(urlLink);
            }
            else {
                // 👇 Cancel pressed
                if (typeof onCancel === 'function') {
                    onCancel(result);
                }
            }
        });
    };
    const handleErrorGetNextStep = (error) => {
        removeLoadingFullScreen();
        showPopup('error', 'Failed', error);
    };
    handleCAllAPI(`${AriForm_1.AriForm.baseUrl}/${AriForm_1.AriForm.serviceId}/${AriForm_1.AriForm.endpointGetNextStep}`, 'POST', body, {}, handleSuccessGetNextStep, handleErrorGetNextStep);
}
exports.callAPINextStep = callAPINextStep;
// hungnq - 25/10/31
